import React, { useState, useRef, useEffect } from "react"
import { TabView, TabPanel } from "primereact/tabview"
import { CardBody, Col, Container, Row, DropdownItem, DropdownMenu, } from "reactstrap"
// import { Col, Row } from "reactstrap"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import "primereact/resources/themes/saga-blue/theme.css"
import "primereact/resources/primereact.min.css"
import "primeicons/primeicons.css"
import { Dialog } from "primereact/dialog"
import { InputText } from "primereact/inputtext"
import { Button } from "primereact/button"
import { Dropdown } from "primereact/dropdown"
import { Accordion, AccordionTab } from "primereact/accordion"
import { TreeSelect } from 'primereact/treeselect';
import Modal from "react-bootstrap/Modal";
import { Controller, useForm } from "react-hook-form"
import { emailValidation, MaxLengthValidation, MinLengthValidation, onlyAlphabetsandSpaces, onlyNumbers, passwordPattern } from "utils/Constants"
import axios from "axios"
import moment from "moment"
import { triggerAlert, ConfirmationAlert } from "utils/CommonFunctions"

const Lookup = () => {
    const [isLoading, setIsLoading] = useState(false)
    const [visible1, setVisible1] = useState(false)
    const [street1, setStreet1] = useState('');
    const [street2, setStreet2] = useState('')
    const [selectedCity, setSelectedCity] = useState(null);
    const [addCountries, setAddCountries] = useState([]);
    const [addStates, setAddStates] = useState([]);
    const [selectedState, setSelectedState] = useState(null)
    const [postalCode, setPostalCode] = useState('');
    const [userRoles, setUserRoles] = useState([])
    const [allCompanies, setAllCompanies] = useState([]);
    const [allDepartments, setAllDepartments] = useState([])
    const [companyItem, setCompanyItem] = useState([])
    const [selectedLabel1, setSelectedLabel1] = useState(null);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [groupitem, setgroupitem] = useState([])
    const [selectedGroupKey, setSelectedGroupKey] = useState(null);
    const [categoriesitem, setcategoriesitem] = useState([])

    const { register, handleSubmit, watch, formState: { errors }, trigger, control, setValue, reset } = useForm();

    // const [selectedOptionReports, setSelectedOptionReports] = useState(null)
    const [isDialogVisible, setDialogVisible] = useState(false) // Controls Dialog visibility
    const [selectedUser, setSelectedUser] = useState(null) // Holds selected user for editing
    const handleEdit = user => {
        setSelectedUser(user) // Set selected user for editing
        setDialogVisible(true) // Show dialog
    }
    const viewIcon = rowData => {
        return (
            <Button icon="pi pi-eye" className="p-button-rounded p-button-info" />
        )
    }

    const deleteIcon = rowData => {
        return (
            <Button icon="pi pi-trash" className="p-button-rounded p-button-info" />
        )
    }

    // categories
    const countries = [
        { name: "Frontend", code: "AU" },
        { name: "Backend", code: "BR" },
        { name: "Cloud", code: "CN" },
        { name: "Tester", code: "test" },
    ]

    const countryOptionTemplate = option => {
        return (
            <div className="flex align-items-center">
                <img
                    alt={option.name}
                    src="https://primefaces.org/cdn/primereact/images/flag/flag_placeholder.png"
                    className={`mr-2 flag flag-${option.code.toLowerCase()}`}
                    style={{ width: "18px" }}
                />
                <div>{option.name}</div>
            </div>
        )
    }

    const [outgoingServer, setOutgoingServer] = useState("")
    const [username, setUsername] = useState("")
    const [password, setPassword] = useState("")
    const [fromEmail, setFromEmail] = useState("")
    const [email, setEmail] = useState("")
    const [port, setPort] = useState("")
    const [address, setAddress] = useState("")
    const [useSSL, setUseSSL] = useState(false)
    const [smtpAccounts, setSmtpAccounts] = useState([])
    const [showPassword, setShowPassword] = useState(false)
    const [userList, setUserList] = useState([])
    const [formVisible, setFormVisible] = useState(false) // Controls the form visibility
    const [formData, setFormData] = useState({
        username: "",
        email: "",
        role: "",
        status: "Active", // Default status
        createDate: new Date().toISOString().split("T")[0], // Default to today's date
        password: "", // Password field
    })
    const [isEditMode, setIsEditMode] = useState(null) // True when editing, false when adding
    const [currentIndex, setCurrentIndex] = useState(null) // To track the index of the user being edited


    // Reset form after submit or cancel
    const resetForm = () => {
        reset()
        setFormVisible(false) // Hide the form
        setIsEditMode(null)
    }



    // Options for role and status dropdowns
    const roleOptions = [
        { label: "Admin", value: "Admin" },
        { label: "User", value: "User" },
        { label: "Manager", value: "Manager" },
    ]

    const statusOptions = [
        { label: "Ram, Frontend developer", value: "Active" },
        { label: "Sai, Python developer", value: "Inactive" },
        { label: "Karthik, Data Scientist", value: "Suspended" },
    ]

    // Roles start

    const [isFormVisible, setIsFormVisible] = useState(false)
    const [isEditModeActive, setIsEditModeActive] = useState(false)
    const [userData, setUserData] = useState({
        roleNameField: "",
        creationDateField: "",
        actionField: "",
    })

    const [roleDataList, setRoleDataList] = useState([])

    const [roleOptionsList] = useState([
        { label: "Super Admin", value: "super_admin" },
        { label: "Editor", value: "editor" },
    ])

    const [statusOptionsList] = useState([
        { label: "Active", value: "active" },
        { label: "Inactive", value: "inactive" },
    ])

    // Handle form submission for save or update
    const handleFormSubmission = () => {
        if (isEditModeActive) {
            // Update logic
            const updatedList = [...roleDataList]
            const roleIndex = updatedList.findIndex(
                role => role.roleNameField === userData.roleNameField
            )
            updatedList[roleIndex] = userData
            setRoleDataList(updatedList)
        } else {
            // Add new role logic
            setRoleDataList([...roleDataList, userData])
        }

        resetFormFields()
    }

    // Reset form data and hide form
    const resetFormFields = () => {
        setUserData({
            roleNameField: "",
            creationDateField: "",
            actionField: "",
        })
        setIsFormVisible(false)
        setaddrolespopup(false)
        setIsEditModeActive(false)
    }

 
    // Resume source start

    const [jobTitlesData, setJobTitlesData] = useState([])
    const [isEditDialogVisible, setEditDialogVisible] = useState(false)
    const [currentJobTitle, setCurrentJobTitle] = useState({
        id: "",
        value: "",
        description: "",
        type: "",
    })
    const [isEditing, setIsEditing] = useState(false)

    // Define type options
    const typeOptions = [
        { label: "User", value: "user" },
        { label: "System", value: "system" },
    ]

    const fetchResumeSource = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/resume-source/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.status === 200) {
                const sources = response.data.results.map(source => ({
                    id: source.source_id,
                    value: source.resume_source,
                    description: source.description,
                    type: source.type || 'user',
                }));
                setJobTitlesData(sources);
            } else {
                //console.error('Unexpected status code:', response.status);
            }
        }
        catch (error) {
            //console.error('Error fetching Resume source data:', error);
        }
    }

    // Handle saving a job title (either add or edit)
    const handleSaveJobTitle = async () => {
        // Check if any of the required fields are empty
        if (!currentJobTitle.value || !currentJobTitle.description || !currentJobTitle.type) {
            setEditDialogVisible(false);
            triggerAlert('error', 'Missing Fields', 'Please fill all fields before saving.');
            return;
        }

        try {
            const resumePayload = {
                resume_source: currentJobTitle.value,
                description: currentJobTitle.description,
                type: currentJobTitle.type,
            };

            let response;
            if (isEditing) {
                response = await axios.put(
                    `${process.env.REACT_APP_API_BASE_URL}/api/v1/resume-source/${currentJobTitle.id}/`,
                    resumePayload,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                setJobTitlesData(prevData =>
                    prevData.map(item =>
                        item.id === currentJobTitle.id ? { ...currentJobTitle } : item
                    )
                );
                triggerAlert('success', 'Success', 'Resume source updated successfully.');
            } else {
                response = await axios.post(
                    `${process.env.REACT_APP_API_BASE_URL}/api/v1/resume-source/`,
                    resumePayload,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                // Add new job title with unique id
                const newJobTitle = {
                    id: response.data.source_id,
                    value: response.data.resume_source,
                    description: response.data.description,
                    type: response.data.type,
                };
                setJobTitlesData(prevData => [...prevData, newJobTitle]);
                triggerAlert('success', 'Success', 'Resume source created successfully.');
            }
            handleCancelJobTitle();
        } catch (error) {
            //console.error('Error adding new job title:', error);
            triggerAlert('error', 'Error', 'Failed to save resume source.');
        }
    };

    const handleDeleteResume = async (resumeId) => {
        try {
            await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/v1/resume-source/${resumeId}/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            // Trigger success alert
            triggerAlert('success', 'Success', 'Resume source deleted successfully.');

            // Update state to remove deleted resume
            setJobTitlesData(prevData => prevData.filter(resume => resume.id !== resumeId));

        } catch (error) {
            //console.error('Error deleting Resume source:', error);
            triggerAlert('error', 'Error', 'Failed to delete resume source.');
        }
    };


    // Handle canceling the operation
    const handleCancelJobTitle = () => {
        setEditDialogVisible(false)
        setCurrentJobTitle({ id: "", value: "", description: "", type: "" })
        setIsEditing(false)
    }

    // Edit button
    const editJobTitleIcon = rowData => (
        <Button
            icon="pi pi-pencil"
            onClick={() => {
                setCurrentJobTitle({ ...rowData })
                setEditDialogVisible(true)
                setIsEditing(true)
            }}
            className="p-button-rounded p-button-info"
        />
    )

    // Delete button
    const deleteJobTitleIcon = rowData => (
        <Button
            icon="pi pi-trash"
            onClick={() => handleDeleteResume(rowData.id)}
            className="p-button-rounded p-button-danger"
        />
    )

    // Add new job title button
    const addNewJobTitle = () => {
        setCurrentJobTitle({ id: "", value: "", description: "", type: "" })
        setEditDialogVisible(true)
        setIsEditing(false)
    }

    // Addresses City
    const fetchAddressCity = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/cities/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.status === 200) {
                const cities = response.data.results.map(city => ({
                    id: city.city_id,
                    name: city.name,
                    state_name: city.state_name,
                    country: city.country_name || "Unknown",
                }));
                setCitiesData(cities);
            } else {
                //console.error('Unexpected status code:', response.status);
            }
        } catch (error) {
            //console.error('Error fetching city data:', error);
        }
    };

    const [citiesData, setCitiesData] = useState([])
    const [isCityEditDialogVisible, setCityEditDialogVisible] = useState(false)
    const [currentCity, setCurrentCity] = useState({
        id: "",
        name: "",
        description: "",
        type: "",
    })
    const [isCityEditing, setCityEditing] = useState(false)

    // Define city type options
    const cityTypeOptions = [
        { label: "User", value: "User" },
        { label: "System", value: "System" },
    ]

    // Handle saving a job title (either add or edit)
    const handleSaveCity = async () => {
        if (!currentCity?.name || !selectedCity || !currentCity?.type) {
            triggerAlert('error', 'Missing Fields', 'Please fill all fields before saving.');
            handleCancelCity();
            return;
        }
        const cityPayload = {
            name: currentCity.name,
            state: selectedCity,
            type: currentCity.type,
        };
        try {
            let response;
            if (isEditing) {
                response = await axios.put(
                    `${process.env.REACT_APP_API_BASE_URL}/api/v1/cities/${currentCity.id}/`,
                    cityPayload,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                if (response.status === 200) {
                    setCitiesData((prevData) =>
                        prevData.map((item) =>
                            item.id === currentCity.id ? { ...currentCity } : item
                        )
                    );
                    triggerAlert('success', 'Success', 'City updated successfully.');
                } else {
                    throw new Error(`Failed to update city. Status code: ${response.status}`);
                }
            } else {
                // Create a new schedule
                response = await axios.post(
                    `${process.env.REACT_APP_API_BASE_URL}/api/v1/cities/`,
                    cityPayload,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
                if (response.status === 201) {
                    setCitiesData((prevData) => [
                        ...prevData,
                        {
                            id: response.data.id,
                            name: response.data.name,
                            description: response.data.description,
                            type: response.data.type,
                        },
                    ]);

                    triggerAlert('success', 'Success', 'City updated successfully.');
                } else {
                    throw new Error(`Failed to create City. Status code: ${response.status}`);
                }
            }
            setCityEditDialogVisible(false);
            handleCancelCity();
        } catch (error) {
            //console.error('Error saving city:', error);
            const errorMessage = error.response?.data?.message || `Failed to save city. Status code: ${error.response?.status}` || 'Please try again.';
            triggerAlert('error', 'Error', errorMessage);
        }
    };



    // Handle canceling the operation
    const handleCancelCity = () => {
        setCityEditDialogVisible(false)
        setCurrentCity({ id: "", name: "", description: "", type: "" })
        setCityEditing(false)
    }

    // Edit button
    const editCityIcon = rowData => (
        <Button
            icon="pi pi-pencil"
            onClick={() => {
                setCurrentCity({ ...rowData })
                setCityEditDialogVisible(true)
                setCityEditing(true)
            }}
            className="p-button-rounded p-button-info"
        />
    )

    const handleDeleteCity = async (cityId) => {
        if (!cityId) {
            triggerAlert('warning', 'Warning', 'Invalid City ID.');
            return;
        }
        try {
            await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/v1/cities/${cityId}/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            triggerAlert('success', 'Success', 'City deleted successfully.');
            setCitiesData(prevData => prevData.filter(city => city.id !== cityId));

        } catch (error) {
            //console.error('Error deleting City:', error);
            triggerAlert('error', 'Error', 'Failed to delete City.');
        }
    };


    const deleteCityIcon = (rowData) => (
        <Button
            icon="pi pi-trash"
            onClick={() => handleDeleteCity(rowData.id)}
            className="p-button-rounded p-button-danger"
        />
    );

    // Add new city button
    const addNewCity = () => {
        setCurrentCity({ id: "", name: "" }); // Only set the necessary fields
        setSelectedCountry(null); // Reset country selection
        setSelectedCity(null); // Reset state selection
        setCityEditDialogVisible(true); // Show the dialog
        setCityEditing(false);
    };



    // Fetch states when a country is selected
    // useEffect(() => {
    //   if (selectedCountry) {
    //     getStatesByCountry(selectedCountry);
    //   }
    // }, [selectedCountry]);

    // Fetch states based on selected country ID
    // const getStatesByCountry = async (countryId) => {
    //   try {
    //     const response = await axios.get(
    //       `${process.env.REACT_APP_API_BASE_URL}/api/v1/get-all-states/?country_id=${countryId}`,
    //       {
    //         headers: { Authorization: `Bearer ${token}` },
    //       }
    //     );

    //     if (response.status === 200) {
    //       const formattedStates = response.data.results.map(state => ({
    //         label: state.name, // Show state name in dropdown
    //         value: state.id, // Store state ID
    //       }));

    //       setStatesData(formattedStates);
    //       setSelectedCity(null); // Reset selected city when country changes
    //     }
    //   } catch (error) {
    //     //console.error("Error fetching states:", error);
    //   }
    // };


    // Address State



    // Fetch countries from API
    // useEffect(() => {
    //   fetchCountries();
    // }, []);
    const [loadingCountries, setLoadingCountries] = useState(false);


    const fetchAddressState = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/states/`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            if (response.status === 200) {
                //console.log("API Response:", response.data.results); 

                const states = response.data.results.map(state => ({
                    id: state.state_id,
                    name: state.name,
                    country_name: state.country_name || "Unknown",
                }));

                //console.log("Mapped States Data:", states); 

                setStatesData(states);
            }
        } catch (error) {
            //console.error('Error fetching state data:', error);
        }
    };

    const [statesData, setStatesData] = useState([])
    const [isStateEditDialogVisible, setStateEditDialogVisible] = useState(false)
    const [currentEditingState, setCurrentEditingState] = useState({
        id: "",
        name: "",
        description: "",
        type: "",
    })
    const [isStateEditing, setIsStateEditing] = useState(false)

    // Define type options
    const stateTypeOptions = [
        { label: "User", value: "user" },
        { label: "System", value: "system" },
    ]

    // Handle saving a state (either add or edit)
    const handleSaveState = () => {
        if (currentEditingState.name && selectedCountry) {
            // Find the country name based on the selected country ID
            const countryObj = countriesData.find(c => c.id === selectedCountry);
            const countryName = countryObj ? countryObj.name : "Unknown";

            const newState = {
                ...currentEditingState,
                country_id: selectedCountry, // Save country ID
                country_name: countryName, // Save country name for display
                id: isStateEditing ? currentEditingState.id : Date.now().toString(),
            };

            if (isStateEditing) {
                setStatesData(prevData =>
                    prevData.map(item =>
                        item.id === currentEditingState.id ? newState : item
                    )
                );
                triggerAlert("success", "Success", "State updated successfully.");
            } else {
                setStatesData(prevData => [...prevData, newState]);
                triggerAlert("success", "Success", "State created successfully.");
            }

            handleCancelState();
        } else {
            triggerAlert("error", "Oops...", "Please fill all fields before saving.");
            handleCancelState();
        }
    };


    // Handle canceling the operation
    const handleCancelState = () => {
        setStateEditDialogVisible(false)
        setCurrentEditingState({ id: "", name: "", description: "", type: "" })
        setIsStateEditing(false)
    }

    // Edit button
    const editStateIcon = rowData => (
        <Button
            icon="pi pi-pencil"
            onClick={() => {
                setCurrentEditingState({ ...rowData })
                setStateEditDialogVisible(true)
                setIsStateEditing(true)
            }}
            className="p-button-rounded p-button-info"
        />
    )

    // Delete button

    const handleDeleteState = async (stateId) => {
        try {
            await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/v1/states/${stateId}/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            // Trigger success alert
            triggerAlert('success', 'Success', 'State deleted successfully.');

            // Update state to remove deleted entry
            setStatesData(prevData => prevData.filter(state => state.id !== stateId));

        } catch (error) {
            //console.error('Error deleting state:', error);
            triggerAlert('error', 'Error', 'Failed to delete state.');
        }
    };

    const deleteStateIcon = rowData => (
        <Button
            icon="pi pi-trash"
            onClick={() => handleDeleteState(rowData.id)}
            className="p-button-rounded p-button-danger"
        />
    );


    // Add new state button
    const addNewState = () => {
        setCurrentEditingState({ id: "", name: "" });
        setSelectedCountry(null); // Reset selected country
        setStateEditDialogVisible(true);
        setIsStateEditing(false);
    };

    // Address country start

    const fetchAddressCountry = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/countries/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.status === 200) {
                const countries = response.data.results.map(country => ({
                    id: country.country_id,
                    name: country.name,
                    description: country.name,
                    type: 'Country',
                }));
                setCountriesData(countries);
            } else {
                //console.error('Unexpected status code:', response.status);
            }
        } catch (error) {
            //console.error('Error fetching country data:', error);
        }
    };
    const [countriesData, setCountriesData] = useState([])
    const [isCountryDialogVisible, setCountryDialogVisible] = useState(false)
    const [currentCountry, setCurrentCountry] = useState({
        id: "",
        name: "",
        description: "",
        type: "",
    })
    const [isCountryBeingEdited, setCountryBeingEdited] = useState(false)

    const countryTypeOptions = [
        { label: "User", value: "User" },
        { label: "System", value: "System" },
    ]

    const handleSaveCountry = async () => {
        // Ensure name is not empty
        if (!currentCountry.name.trim()) {
            setCountryDialogVisible(false);
            triggerAlert('error', 'Error', 'Please provide a valid country name.');
            return;
        }

        // Ensure type has a valid value
        if (!currentCountry.type) {
            currentCountry.type = 'Country'; // Default to "Country" if empty
        }

        // Auto-fill description if missing
        if (!currentCountry.description) {
            currentCountry.description = currentCountry.name;
        }

        try {
            if (isCountryBeingEdited) {
                await axios.put(
                    `${process.env.REACT_APP_API_BASE_URL}/api/v1/countries/${currentCountry.id}/`,
                    {
                        name: currentCountry.name,
                        description: currentCountry.description,
                        type: currentCountry.type,
                    },
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );
                setCountriesData(prevData =>
                    prevData.map(item => (item.id === currentCountry.id ? { ...currentCountry } : item))
                );

                triggerAlert('success', 'Success', 'Country updated successfully.');
            } else {
                const response = await axios.post(
                    `${process.env.REACT_APP_API_BASE_URL}/api/v1/countries/`,
                    {
                        name: currentCountry.name,
                        description: currentCountry.description,
                        type: currentCountry.type,
                    },
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );

                setCountriesData(prevData => [...prevData, { ...currentCountry, id: response.data.id }]);

                triggerAlert('success', 'Success', 'Country created successfully.');
            }

            handleCancelCountry();
        } catch (error) {
            setCountryDialogVisible(false);
            //console.error('Error saving country:', error);
            triggerAlert('error', 'Error', 'Failed to save country.');
        }
    };

    const editCountryIcon = rowData => (
        <Button
            icon="pi pi-pencil"
            onClick={() => {
                //console.log("Editing:", rowData);
                setCurrentCountry({ ...rowData });
                setCountryDialogVisible(true);
                setCountryBeingEdited(true);
            }}
            className="p-button-rounded p-button-info"
        />
    );


    const handleCancelCountry = () => {
        setCountryDialogVisible(false)
        setCurrentCountry({ id: "", name: "", description: "", type: "" })
        setCountryBeingEdited(false)
    }

    const deleteCountryIcon = rowData => (
        <Button
            icon="pi pi-trash"
            onClick={() => handleDeleteCountry(rowData.id)} // Pass only rowData.id
            className="p-button-rounded p-button-danger"
        />
    );

    const handleDeleteCountry = async (countryId) => {
        try {
            await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/v1/countries/${countryId}/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            // Trigger success alert
            triggerAlert('success', 'Success', 'Country deleted successfully.');

            // Update state to remove deleted country
            setCountriesData(prevData => prevData.filter(country => country.id !== countryId));

        } catch (error) {
            //console.error('Error deleting country:', error);
            triggerAlert('error', 'Error', 'Failed to delete country.');
        }
    };

    const addNewCountry = () => {
        setCurrentCountry({
            id: "",
            name: "",
            description: "",
            type: "Country",
        });
        setCountryDialogVisible(true);
        setCountryBeingEdited(false);
    };


    // Address country end

    // Address label start

    const [addressLabelsData, setAddressLabelsData] = useState([])
    const [isAddressLabelEditDialogVisible, setAddressLabelEditDialogVisible] =
        useState(false)
    const [currentAddressLabel, setCurrentAddressLabel] = useState({
        id: "",
        label: "",
        output: "",
        type: "",
    })
    const [isEditingAddressLabel, setIsEditingAddressLabel] = useState(false)

    // Define address label type options
    const addressLabelTypeOptions = [
        { label: "User", value: "User" },
        { label: "System", value: "System" },
    ]

    // Handle saving an address label (either add or edit)
    const handleSaveAddressLabel = () => {
        if (
            currentAddressLabel.label &&
            currentAddressLabel.output &&
            currentAddressLabel.type
        ) {
            if (isEditingAddressLabel) {
                // Update existing address label
                setAddressLabelsData(prevData =>
                    prevData.map(item =>
                        item.id === currentAddressLabel.id
                            ? { ...currentAddressLabel }
                            : item
                    )
                )
            } else {
                // Add new address label with a unique id
                const newAddressLabel = {
                    ...currentAddressLabel,
                    id: Date.now().toString(),
                }
                setAddressLabelsData(prevData => [...prevData, newAddressLabel])
            }
            handleCancelAddressLabel()
        } else {
            alert("Please fill all fields before saving.")
        }
    }

    // Handle canceling the operation
    const handleCancelAddressLabel = () => {
        setAddressLabelEditDialogVisible(false)
        setCurrentAddressLabel({ id: "", label: "", output: "", type: "" })
        setIsEditingAddressLabel(false)
    }

    // Edit button
    const editAddressLabelIcon = rowData => (
        <Button
            icon="pi pi-pencil"
            onClick={() => {
                setCurrentAddressLabel({ ...rowData })
                setAddressLabelEditDialogVisible(true)
                setIsEditingAddressLabel(true)
            }}
            className="p-button-rounded p-button-info"
        />
    )

    // Delete button
    const deleteAddressLabelIcon = rowData => (
        <Button
            icon="pi pi-trash"
            onClick={() => {
                setAddressLabelsData(prevData =>
                    prevData.filter(item => item.id !== rowData.id)
                )
            }}
            className="p-button-rounded p-button-danger"
        />
    )

    // Add new address label button
    const addNewAddressLabel = () => {
        setCurrentAddressLabel({ id: "", label: "", output: "", type: "" })
        setAddressLabelEditDialogVisible(true)
        setIsEditingAddressLabel(false)
    }

    // Address Label end

    // Skill start

    const [skillsData, setSkillsData] = useState([])
    const [isSkillEditDialogVisible, setSkillEditDialogVisible] = useState(false)
    const [currentSkill, setCurrentSkill] = useState({
        id: "",
        name: "",
        description: "",
        type: "", // Added type field
    })
    const [isEditingSkill, setIsEditingSkill] = useState(false)

    // Define skill type options
    const skillTypeOptions = [
        { label: "user", value: "user" },
        { label: "system", value: "system" },
    ]

    // Fetch data from the API
    const fetchSkills = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/skills/`);
            if (response.status === 200) {
                const skills = response.data.results.map(skill => ({
                    id: skill.skill_id,
                    name: skill.skill_name,
                    description: skill.description,
                    type: skill.type || 'user', // Assuming 'user' as default type if not provided
                }));
                setSkillsData(skills);
            }
        } catch (error) {
            //console.error('Error fetching skills data:', error);
        }
    };
    // Handle saving a skill (either add or edit)
    const handleSaveSkill = async () => {
        if (currentSkill.name && currentSkill.description && currentSkill.type) {
            try {
                let response;
                const req = {
                    skill_name: currentSkill.name,
                    description: currentSkill.description,
                    type: currentSkill.type,
                };

                if (isEditingSkill) {
                    // Update existing skill
                    response = await axios.put(
                        `${process.env.REACT_APP_API_BASE_URL}/api/v1/skills/${currentSkill.id}/`,
                        req,
                        {
                            headers: {
                                Authorization: `Bearer ${token}`,
                            },
                        }
                    );

                    if (response.status === 200) {
                        setSkillsData(prevData =>
                            prevData.map(item =>
                                item.id === currentSkill.id ? { ...currentSkill } : item
                            )
                        );
                        triggerAlert('success', 'Success', 'Skill updated successfully.');
                        handleCancelSkill(); // Close modal on success
                    } else {
                        throw new Error('Failed to update skill. Please try again.');
                    }
                } else {
                    // Add new skill
                    response = await axios.post(
                        `${process.env.REACT_APP_API_BASE_URL}/api/v1/skills/`,
                        req,
                        {
                            headers: {
                                Authorization: `Bearer ${token}`,
                            },
                        }
                    );

                    if (response.status === 201) {
                        const newSkill = {
                            id: response.data.skill_id,
                            name: response.data.skill_name,
                            description: response.data.description,
                            type: response.data.type,
                        };
                        setSkillsData(prevData => [...prevData, newSkill]);
                        triggerAlert('success', 'Success', 'Skill created successfully.');
                        handleCancelSkill(); // Close modal on success
                    } else {
                        throw new Error('Failed to save skill. Please try again.');
                    }
                }
            } catch (error) {
                //console.error('Error saving skill:', error);
                triggerAlert('error', 'Error', error.message || 'Failed to save skill. Please try again.');
                handleCancelSkill();
            }
        } else {
            triggerAlert('error', 'Missing Fields', 'Please fill all fields before saving.');
            handleCancelSkill();
        }
    };

    // Handle canceling the operation
    const handleCancelSkill = () => {
        setSkillEditDialogVisible(false)
        setCurrentSkill({ id: "", name: "", description: "", type: "" })
        setIsEditingSkill(false)
    }

    // Edit button
    const editSkillIcon = rowData => (
        <Button
            icon="pi pi-pencil"
            onClick={() => {
                setCurrentSkill({ ...rowData })
                setSkillEditDialogVisible(true)
                setIsEditingSkill(true)
                fetchSkills()
            }}
            className="p-button-rounded p-button-info"
        />
    )

    //Delete function
    const handleDeleteSkill = async (skillId) => {
        try {
            await axios.delete(
                `${process.env.REACT_APP_API_BASE_URL}/api/v1/skills/${skillId}/`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            // Remove deleted skill from the state
            setSkillsData(prevData => prevData.filter(skill => skill.id !== skillId));

            // Show success message
            triggerAlert('success', 'Success', 'Skill deleted successfully.');

            // Fetch updated skills list
            fetchSkills();
        } catch (error) {
            //console.error('Error deleting skill:', error);
            triggerAlert('error', 'Error', 'Failed to delete skill.');
        }
    };


    // Delete button
    const deleteSkillIcon = rowData => (
        <Button
            icon="pi pi-trash"
            onClick={() => handleDeleteSkill(rowData.id)}
            className="p-button-rounded p-button-danger"
        />
    )

    // Add new skill button
    const addNewSkill = () => {
        setCurrentSkill({ id: "", name: "", description: "", type: "" })
        setSkillEditDialogVisible(true)
        setIsEditingSkill(false)
    }

    // Skill end

    // Employee type start

    const [employeesData, setEmployeesData] = useState([])
    const [isEmployeeEditDialogVisible, setEmployeeEditDialogVisible] =
        useState(false)
    const [currentEmployee, setCurrentEmployee] = useState({
        id: "",
        value: "",
        description: "",
        type: "", // Added type field
    })
    const [isEditingEmployee, setIsEditingEmployee] = useState(false)

    // Define employee type options
    const employeeTypeOptions = [
        { label: "User", value: "user" },
        { label: "System", value: "system" },
    ]
    const fetchEmployeeType = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/employee-type/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.status === 200) {
                const employees = response.data.results.map(employee => ({
                    id: employee.id,
                    name: employee.employee_type,
                    description: employee.description,
                    type: employee.type || 'user',
                }));
                setEmployeesData(employees);
            }
        } catch (error) {
            //console.error('Error fetching employees data:', error);
        }
    };


    // Handle saving an employee (either add or edit)
    const handleSaveEmployee = async () => {
        if (currentEmployee.name && currentEmployee.description && currentEmployee.type) {
            try {
                const req = {
                    employee_type: currentEmployee.name,
                    description: currentEmployee.description,
                    type: currentEmployee.type,
                };

                let response;
                let updatedData;

                if (isEditingEmployee) {
                    // Update existing employee
                    response = await axios.put(
                        `${process.env.REACT_APP_API_BASE_URL}/api/v1/employee-type/${currentEmployee.id}/`,
                        req,
                        {
                            headers: {
                                Authorization: `Bearer ${token}`,
                            },
                        }
                    );

                    if (response.status === 200) {
                        updatedData = employeesData.map(item =>
                            item.id === currentEmployee.id ? { ...currentEmployee } : item
                        );
                        triggerAlert('success', 'Success', 'Employee type updated successfully.');
                        setEmployeesData(updatedData);
                    } else {
                        throw new Error('Failed to update employee type. Please try again.');
                    }
                } else {
                    // Add new employee
                    response = await axios.post(
                        `${process.env.REACT_APP_API_BASE_URL}/api/v1/employee-type/`,
                        req,
                        {
                            headers: {
                                Authorization: `Bearer ${token}`,
                            },
                        }
                    );

                    if (response.status === 201) {
                        const newEmployee = {
                            id: response.data.id,
                            name: response.data.employee_type,
                            description: response.data.description,
                            type: response.data.type,
                        };
                        updatedData = [...employeesData, newEmployee];
                        triggerAlert('success', 'Success', 'Employee type created successfully.');
                        setEmployeesData(updatedData);
                    } else {
                        throw new Error('Failed to create employee type. Please try again.');
                    }
                }

                handleCancelEmployee(); // Close modal on success
            } catch (error) {
                //console.error('Error saving employee type:', error);
                triggerAlert('error', 'Error', error.message || 'Failed to save employee type. Please try again.');
                handleCancelEmployee(); // Close modal on failure
            }
        } else {
            triggerAlert('error', 'Missing Fields', 'Please fill all fields before saving.');
            handleCancelEmployee(); // Close modal on validation failure
        }
    };




    // Handle canceling the operation
    const handleCancelEmployee = () => {
        setEmployeeEditDialogVisible(false)
        setCurrentEmployee({ id: "", value: "", description: "", type: "" })
        setIsEditingEmployee(false)
    }

    // Edit button
    const editEmployeeIcon = rowData => (
        <Button
            icon="pi pi-pencil"
            onClick={() => {
                setCurrentEmployee({ ...rowData })
                setEmployeeEditDialogVisible(true)
                setIsEditingEmployee(true)
            }}
            className="p-button-rounded p-button-info"
        />
    )
    const handleDeleteEmployee = async (resumeId) => {
        try {
            await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/v1/employee-type/${resumeId}/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            // Show success message
            triggerAlert('success', 'Success', 'Employee type deleted successfully.');

            // Correct state update
            setEmployeesData(prevData => prevData.filter(employee => employee.id !== resumeId));

        } catch (error) {
            //console.error('Error deleting Employee type:', error);
            triggerAlert('error', 'Error', 'Failed to delete employee type.');
        }
    };


    const deleteEmployeeIcon = (rowData) => (
        <Button
            icon="pi pi-trash"
            onClick={() => handleDeleteEmployee(rowData.id)}
            className="p-button-rounded p-button-danger"
        />
    );


    // Add new employee button
    const addNewEmployee = () => {
        setCurrentEmployee({ id: "", name: "", description: "", type: "" })
        setEmployeeEditDialogVisible(true)
        setIsEditingEmployee(false)
    }

    // Employee type end

    // Source type start

    const [sourcesData, setSourcesData] = useState([])
    const [isSourceEditDialogVisible, setSourceEditDialogVisible] =
        useState(false)
    const [currentSource, setCurrentSource] = useState({
        id: "",
        name: "",
        description: "",
        type: "",
    })
    const [isEditingSource, setIsEditingSource] = useState(false)

    // Define source type options
    const sourceTypeOptions = [
        { label: "User", value: "user" },
        { label: "System", value: "system" },
    ]

    // Handle saving a source (either add or edit)
    const handleSaveSource = () => {
        if (currentSource.name && currentSource.description && currentSource.type) {
            if (isEditingSource) {
                // Update existing source
                setSourcesData(prevData =>
                    prevData.map(item =>
                        item.id === currentSource.id ? { ...currentSource } : item
                    )
                )
            } else {
                // Add new source with a unique id
                const newSource = {
                    ...currentSource,
                    id: Date.now().toString(),
                }
                setSourcesData(prevData => [...prevData, newSource])
            }
            handleCancelSource()
        } else {
            alert("Please fill all fields before saving.")
        }
    }

    // Handle canceling the operation
    const handleCancelSource = () => {
        setSourceEditDialogVisible(false)
        setCurrentSource({ id: "", name: "", description: "", type: "" })
        setIsEditingSource(false)
    }

    // Edit button
    const editSourceIcon = rowData => (
        <Button
            icon="pi pi-pencil"
            onClick={() => {
                setCurrentSource({ ...rowData })
                setSourceEditDialogVisible(true)
                setIsEditingSource(true)
            }}
            className="p-button-rounded p-button-info"
        />
    )

    // Delete button
    const deleteSourceIcon = rowData => (
        <Button
            icon="pi pi-trash"
            onClick={() => {
                setSourcesData(prevData =>
                    prevData.filter(item => item.id !== rowData.id)
                )
            }}
            className="p-button-rounded p-button-danger"
        />
    )

    // Add new source button
    const addNewSource = () => {
        setCurrentSource({ id: "", name: "", description: "", type: "" })
        setSourceEditDialogVisible(true)
        setIsEditingSource(false)
    }

    // Source type end

    // Reffered by start

    const [referredData, setReferredData] = useState([])
    const [isReferredEditDialogVisible, setReferredEditDialogVisible] =
        useState(false)
    const [currentReferred, setCurrentReferred] = useState({
        id: "",
        value: "",
        description: "",
        type: "",
    })
    const [isEditingReferred, setIsEditingReferred] = useState(false)

    // Define referred type options
    const referredTypeOptions = [
        { label: "User", value: "user" },
        { label: "System", value: "system" },
    ]

    // Handle saving a referred (either add or edit)
    const handleSaveReferred = () => {
        if (
            currentReferred.value &&
            currentReferred.description &&
            currentReferred.type
        ) {
            if (isEditingReferred) {
                // Update existing referred
                setReferredData(prevData =>
                    prevData.map(item =>
                        item.id === currentReferred.id ? { ...currentReferred } : item
                    )
                )
            } else {
                // Add new referred with a unique id
                const newReferred = {
                    ...currentReferred,
                    id: Date.now().toString(),
                }
                setReferredData(prevData => [...prevData, newReferred])
            }
            handleCancelReferred()
        } else {
            alert("Please fill all fields before saving.")
        }
    }

    // Handle canceling the operation
    const handleCancelReferred = () => {
        setReferredEditDialogVisible(false)
        setCurrentReferred({ id: "", value: "", description: "", type: "" })
        setIsEditingReferred(false)
    }

    // Edit button
    const editReferredIcon = rowData => (
        <Button
            icon="pi pi-pencil"
            onClick={() => {
                setCurrentReferred({ ...rowData })
                setReferredEditDialogVisible(true)
                setIsEditingReferred(true)
            }}
            className="p-button-rounded p-button-info"
        />
    )

    // Delete button
    const deleteReferredIcon = rowData => (
        <Button
            icon="pi pi-trash"
            onClick={() => {
                setReferredData(prevData =>
                    prevData.filter(item => item.id !== rowData.id)
                )
            }}
            className="p-button-rounded p-button-danger"
        />
    )

    // Add new referred button
    const addNewReferred = () => {
        setCurrentReferred({ id: "", value: "", description: "", type: "" })
        setReferredEditDialogVisible(true)
        setIsEditingReferred(false)
    }

    // Reffered by end

    // Doc type start

    const [docTypeData, setDocTypeData] = useState([])
    const [isDocTypeEditDialogVisible, setDocTypeEditDialogVisible] =
        useState(false)
    const [currentDocType, setCurrentDocType] = useState({
        id: "",
        value: "",
        description: "",
        type: "",
    })
    const [isEditingDocType, setIsEditingDocType] = useState(false)

    // Define Doc. Type options
    const docTypeOptions = [
        { label: "User", value: "user" },
        { label: "System", value: "system" },
    ]

    // Handle saving a Doc. Type (either add or edit)
    const handleSaveDocType = () => {
        if (
            currentDocType.value &&
            currentDocType.description &&
            currentDocType.type
        ) {
            if (isEditingDocType) {
                // Update existing Doc. Type
                setDocTypeData(prevData =>
                    prevData.map(item =>
                        item.id === currentDocType.id ? { ...currentDocType } : item
                    )
                )
            } else {
                // Add new Doc. Type with a unique id
                const newDocType = {
                    ...currentDocType,
                    id: Date.now().toString(),
                }
                setDocTypeData(prevData => [...prevData, newDocType])
            }
            handleCancelDocType()
        } else {
            alert("Please fill all fields before saving.")
        }
    }

    // Handle canceling the operation
    const handleCancelDocType = () => {
        setDocTypeEditDialogVisible(false)
        setCurrentDocType({ id: "", value: "", description: "", type: "" })
        setIsEditingDocType(false)
    }

    // Edit button
    const editDocTypeIcon = rowData => (
        <Button
            icon="pi pi-pencil"
            onClick={() => {
                setCurrentDocType({ ...rowData })
                setDocTypeEditDialogVisible(true)
                setIsEditingDocType(true)
            }}
            className="p-button-rounded p-button-info"
        />
    )

    // Delete button
    const deleteDocTypeIcon = rowData => (
        <Button
            icon="pi pi-trash"
            onClick={() => {
                setDocTypeData(prevData =>
                    prevData.filter(item => item.id !== rowData.id)
                )
            }}
            className="p-button-rounded p-button-danger"
        />
    )

    // Add new Doc. Type button
    const addNewDocType = () => {
        setCurrentDocType({ id: "", value: "", description: "", type: "" })
        setDocTypeEditDialogVisible(true)
        setIsEditingDocType(false)
    }

    // Job type end

    // Degree start

    const [degreeData, setDegreeData] = useState([])
    const [isDegreeEditDialogVisible, setDegreeEditDialogVisible] =
        useState(false)
    const [currentDegree, setCurrentDegree] = useState({
        id: "",
        value: "",
        description: "",
        type: "",
    })
    const [isEditingDegree, setIsEditingDegree] = useState(false)

    const degreeTypeOptions = [
        { label: "User", value: "user" },
        { label: "System", value: "system" },
    ]

    const fetchDegree = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/degrees/`);
            if (response.status === 200) {
                const degrees = response.data.map(degree => ({
                    id: degree.id,
                    value: degree.institution_type,
                    description: degree.description,
                    type: degree.type || 'user',
                }));
                setDegreeData(degrees);
            } else {
                //console.error('Unexpected status code:', response.status);
            }
        }
        catch (error) {
            //console.error('Error fetching degree data:', error);
        }

    }

    const handleSaveDegree = async () => {
        if (!currentDegree.value || !currentDegree.description || !currentDegree.type) {
            setDegreeEditDialogVisible(false);
            triggerAlert('error', 'Missing Fields', 'Please fill all fields before saving.');
            return;
        }

        const degreePayload = {
            institution_type: currentDegree.value,
            description: currentDegree.description,
            type: currentDegree.type,
        };

        try {
            if (isEditingDegree) {
                // Update existing degree
                await axios.put(
                    `${process.env.REACT_APP_API_BASE_URL}/api/v1/degrees/${currentDegree.id}/`,
                    degreePayload
                );
                triggerAlert('success', 'Success', 'Degree updated successfully.');

                setDegreeData((prevData) =>
                    prevData.map((item) =>
                        item.id === currentDegree.id ? { ...currentDegree } : item
                    )
                );
            } else {
                // Create a new degree
                const response = await axios.post(
                    `${process.env.REACT_APP_API_BASE_URL}/api/v1/degrees/`,
                    degreePayload
                );
                triggerAlert('success', 'Success', 'Degree created successfully.');

                // Add new degree
                setDegreeData((prevData) => [
                    ...prevData,
                    { id: response.data.id, ...degreePayload },
                ]);
            }

            handleCancelDegree();
        } catch (error) {
            //console.error('Error saving degree:', error);
            triggerAlert('error', 'Error', error.response?.data?.message || 'Failed to save degree. Please try again.');
        }
    };


    // Handle canceling the operation
    const handleCancelDegree = () => {
        setDegreeEditDialogVisible(false)
        setCurrentDegree({ id: "", value: "", description: "", type: "" })
        setIsEditingDegree(false)
    }

    // Edit button
    const editDegreeIcon = rowData => (
        <Button
            icon="pi pi-pencil"
            onClick={() => {
                setCurrentDegree({ ...rowData })
                setDegreeEditDialogVisible(true)
                setIsEditingDegree(true)
            }}
            className="p-button-rounded p-button-info"
        />
    )

    //Delete function
    const handleDeleteDegree = async (degreeId) => {
        if (!degreeId) {
            triggerAlert('warning', 'Warning', 'Invalid degree ID.');
            return;
        }

        try {
            await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/v1/degrees/${degreeId}/`);

            triggerAlert('success', 'Success', 'Degree  deleted successfully.');

            setDegreeData((prevData) => prevData.filter((degree) => degree.id !== degreeId));
        } catch (error) {
            //console.error('Error deleting degree:', error);

            triggerAlert(
                'error',
                'Error',
                error.response?.data?.message || 'Failed to delete Degree. Please try again.'
            );
        }
    };


    // Delete button
    const deleteDegreeIcon = rowData => (
        <Button
            icon="pi pi-trash"
            onClick={() => handleDeleteDegree(rowData.id)}
            className="p-button-rounded p-button-danger"
        />
    )

    // Add new Degree button
    const addNewDegree = () => {
        setCurrentDegree({ id: "", value: "", description: "", type: "" })
        setDegreeEditDialogVisible(true)
        setIsEditingDegree(false)
    }

    // degree end


    // Institute start

    const [institutionData, setInstitutionData] = useState([])
    const [isInstitutionEditDialogVisible, setInstitutionEditDialogVisible] =
        useState(false)
    const [currentInstitution, setCurrentInstitution] = useState({
        id: "",
        value: "",
        description: "",
        type: "",
    })
    const [isEditingInstitution, setIsEditingInstitution] = useState(false)

    // Define Institution type options
    const institutionTypeOptions = [
        { label: "User", value: "user" },
        { label: "System", value: "system" },

    ]

    // Handle saving an Institution (either add or edit)
    const handleSaveInstitution = () => {
        if (
            currentInstitution.value &&
            currentInstitution.description &&
            currentInstitution.type
        ) {
            if (isEditingInstitution) {
                // Update existing Institution
                setInstitutionData(prevData =>
                    prevData.map(item =>
                        item.id === currentInstitution.id ? { ...currentInstitution } : item
                    )
                )
            } else {
                // Add new Institution with a unique id
                const newInstitution = {
                    ...currentInstitution,
                    id: Date.now().toString(),
                }
                setInstitutionData(prevData => [...prevData, newInstitution])
            }
            handleCancelInstitution()
        } else {
            alert("Please fill all fields before saving.")
        }
    }

    // Handle canceling the operation
    const handleCancelInstitution = () => {
        setInstitutionEditDialogVisible(false)
        setCurrentInstitution({ id: "", value: "", description: "", type: "" })
        setIsEditingInstitution(false)
    }

    // Edit button
    const editInstitutionIcon = rowData => (
        <Button
            icon="pi pi-pencil"
            onClick={() => {
                setCurrentInstitution({ ...rowData })
                setInstitutionEditDialogVisible(true)
                setIsEditingInstitution(true)
            }}
            className="p-button-rounded p-button-info"
        />
    )

    // Delete button
    const deleteInstitutionIcon = rowData => (
        <Button
            icon="pi pi-trash"
            onClick={() => {
                setInstitutionData(prevData =>
                    prevData.filter(item => item.id !== rowData.id)
                )
            }}
            className="p-button-rounded p-button-danger"
        />
    )

    // Add new Institution button
    const addNewInstitution = () => {
        setCurrentInstitution({ id: "", value: "", description: "", type: "" })
        setInstitutionEditDialogVisible(true)
        setIsEditingInstitution(false)
    }

    // institute end

    // Job status start


    const [jobStatusData, setJobStatusData] = useState([])
    const [isJobStatusDialogVisible, setJobStatusDialogVisible] = useState(false)
    const [currentJobStatus, setCurrentJobStatus] = useState({
        id: "",
        value: "",
        description: "",
        type: "",
    })
    const [isEditingJobStatus, setIsEditingJobStatus] = useState(false)

    // Define Job Status type options
    const jobStatusTypeOptions = [
        { label: "User", value: "user" },
        { label: "System", value: "system" },
    ]

    const fetchJobStatus = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/job-status/`);
            if (response.status === 200) {
                const jobStatus = response.data.results.map(status => ({
                    id: status.id,
                    value: status.job_status,
                    description: status.description,
                    type: status.type || 'user',
                }));
                setJobStatusData(jobStatus);
            } else {
                //console.error('Unexpected status code:', response.status);
            }
        }
        catch (error) {
            //console.error('Error fetching Job status data:', error);
        }

    }

    // Handle saving a Job Status (either add or edit)
    const handleSaveJobStatus = async () => {
        if (!currentJobStatus.value || !currentJobStatus.description || !currentJobStatus.type) {
            setJobStatusDialogVisible(false)
            triggerAlert('error', 'Missing Fields', 'Please fill all fields before saving.');
            return;
        }
        const jobStatusPayload = {
            job_status: currentJobStatus.value,
            description: currentJobStatus.description,
            type: currentJobStatus.type,
        };

        try {
            if (isEditingJobStatus) {
                // Update existing Job Status
                await axios.put(
                    `${process.env.REACT_APP_API_BASE_URL}/api/v1/job-status/${currentJobStatus.id}/`,
                    jobStatusPayload
                );
                triggerAlert('success', 'Success', 'Job status updated successfully.');
                setJobStatusData(prevData =>
                    prevData.map(item =>
                        item.id === currentJobStatus.id ? { ...currentJobStatus } : item
                    )
                );
            } else {
                const response = await axios.post(
                    `${process.env.REACT_APP_API_BASE_URL}/api/v1/job-status/`,
                    jobStatusPayload
                );
                triggerAlert('success', 'Success', 'Degree created successfully.');

                // Add new Job Status with a unique id
                setJobStatusData((prevData) => [
                    ...prevData,
                    { id: response.data.id, ...jobStatusPayload },
                ]);
            }
            handleCancelJobStatus();
        } catch (error) {
            //console.error('Error saving job status:', error);
            triggerAlert('error', 'Error', error.response?.data?.message || 'Failed to save job status. Please try again.');
        }
    };

    // Handle canceling the operation
    const handleCancelJobStatus = () => {
        setJobStatusDialogVisible(false)
        setCurrentJobStatus({ id: "", value: "", description: "", type: "" })
        setIsEditingJobStatus(false)
    }

    // Edit button
    const editJobStatusIcon = rowData => (
        <Button
            icon="pi pi-pencil"
            onClick={() => {
                setCurrentJobStatus({ ...rowData })
                setJobStatusDialogVisible(true)
                setIsEditingJobStatus(true)
            }}
            className="p-button-rounded p-button-info"
        />
    )

    //Delete function
    const handleDeleteJobStatus = async (statusId) => {
        if (!statusId) {
            triggerAlert('warning', 'Warning', 'Invalid Job status ID.');
            return;
        }

        try {
            await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/v1/job-status/${statusId}/`);

            triggerAlert('success', 'Success', 'Job status  deleted successfully.');

            setJobStatusData((prevData) => prevData.filter((status) => status.id !== statusId));
        } catch (error) {
            //console.error('Error deleting job status:', error);

            triggerAlert(
                'error',
                'Error',
                error.response?.data?.message || 'Failed to delete job status. Please try again.'
            );
        }
    };

    // Delete button
    const deleteJobStatusIcon = rowData => (
        <Button
            icon="pi pi-trash"
            onClick={() => handleDeleteJobStatus(rowData.id)}
            className="p-button-rounded p-button-danger"
        />
    )

    // Add new Job Status button
    const addNewJobStatus = () => {
        setCurrentJobStatus({ id: "", value: "", description: "", type: "" })
        setJobStatusDialogVisible(true)
        setIsEditingJobStatus(false)
    }

    // Job status end

    // worktype start

    const [workTypeData, setWorkTypeData] = useState([])
    const [isWorkTypeDialogVisible, setWorkTypeDialogVisible] = useState(false)
    const [currentWorkType, setCurrentWorkType] = useState({
        id: "",
        value: "",
        description: "",
        type: "",
    })
    const [isEditingWorkType, setIsEditingWorkType] = useState(false)

    const workTypeOptions = [
        { label: "User", value: "user" },
        { label: "System", value: "system" },
    ]

    const fetchWorkPlace = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/workplace-type/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.status === 200) {
                const workPlaces = response.data.results.map(workPlace => ({
                    id: workPlace.id,
                    value: workPlace.workplace_type,
                    description: workPlace.description,
                    type: workPlace.type
                }));
                setWorkTypeData(workPlaces);
            }
        } catch (error) {
            //console.error('Error fetching  data:', error);
        }
    };

    const handleSaveWorkType = async () => {
        if (!currentWorkType.value || !currentWorkType.description || !currentWorkType.type) {
            setWorkTypeDialogVisible(false);
            triggerAlert('error', 'Missing Fields', 'Please fill all fields before saving.');
            return;
        }

        const req = {
            workplace_type: currentWorkType.value,
            description: currentWorkType.description,
            type: currentWorkType.type,
        };

        const headers = {
            Authorization: `Bearer ${token}`,
        };

        try {
            let response;

            if (isEditingWorkType) {
                // Update existing work type
                response = await axios.put(
                    `${process.env.REACT_APP_API_BASE_URL}/api/v1/workplace-type/${currentWorkType.id}/`,
                    req,
                    { headers }
                );

                setWorkTypeData((prevData) =>
                    prevData.map((item) =>
                        item.id === currentWorkType.id ? { ...currentWorkType } : item
                    )
                );

                triggerAlert('success', 'Success', 'Work type updated successfully.');
            } else {
                // Create a new work type
                response = await axios.post(
                    `${process.env.REACT_APP_API_BASE_URL}/api/v1/workplace-type/`,
                    req,
                    { headers }
                );

                setWorkTypeData((prevData) => [
                    ...prevData,
                    {
                        id: response.data.id,
                        value: response.data.workplace_type,
                        description: response.data.description,
                        type: response.data.type,
                    },
                ]);

                triggerAlert('success', 'Success', 'Work type created successfully.');
            }

            setWorkTypeDialogVisible(false);
            handleCancelWorkType();
        } catch (error) {
            //console.error('Error saving work type:', error);

            triggerAlert(
                'error',
                'Error',
                error.response?.data?.message || 'Failed to save work type. Please try again.'
            );
        }
    };

    const handleCancelWorkType = () => {
        setWorkTypeDialogVisible(false)
        setCurrentWorkType({ id: "", value: "", description: "", type: "" })
        setIsEditingWorkType(false)
    }

    const editWorkTypeIcon = rowData => (
        <Button
            icon="pi pi-pencil"
            onClick={() => {
                setCurrentWorkType({ ...rowData })
                setWorkTypeDialogVisible(true)
                setIsEditingWorkType(true)
            }}
            className="p-button-rounded p-button-info"
        />
    )

    //Delete function
    const handleDeleteWorkType = async (workId) => {
        if (!workId) {
            triggerAlert('warning', 'Warning', 'Invalid work type ID.');
            return;
        }

        try {
            await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/v1/workplace-type/${workId}/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            triggerAlert('success', 'Success', 'Work type deleted successfully.');

            setWorkTypeData((prevData) => prevData.filter((workType) => workType.id !== workId));
        } catch (error) {
            //console.error('Error deleting work type:', error);

            triggerAlert(
                'error',
                'Error',
                error.response?.data?.message || 'Failed to delete work type. Please try again.'
            );
        }
    };

    const deleteWorkTypeIcon = rowData => (
        <Button
            icon="pi pi-trash"
            onClick={() => handleDeleteWorkType(rowData.id)}
            className="p-button-rounded p-button-danger"
        />
    )

    const addNewWorkType = () => {
        setCurrentWorkType({ id: "", value: "", description: "", type: "" })
        setWorkTypeDialogVisible(true)
        setIsEditingWorkType(false)
    }

    // work type end

    // Job type start

    const [jobTypeData, setJobTypeData] = useState([])
    const [isJobTypeDialogVisible, setJobTypeDialogVisible] = useState(false)
    const [currentJobType, setCurrentJobType] = useState({
        id: "",
        value: "",
        description: "",
        type: "",
    })
    const [isEditingJobType, setIsEditingJobType] = useState(false)

    const jobTypeOptions = [
        { label: "User", value: "user" },
        { label: "System", value: "system" },
    ]
    const fetchJobType = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/job-type/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.status === 200) {
                const jobTypes = response.data.results.map(jobType => ({
                    id: jobType.id,
                    value: jobType.job_type,
                    description: jobType.description,
                    type: jobType.type
                }));
                setJobTypeData(jobTypes);
            }
        } catch (error) {
            //console.error('Error fetching JobType data:', error);
        }
    };


    const handleSaveJobType = async () => {
        if (!currentJobType.value || !currentJobType.description || !currentJobType.type) {
            setJobTypeDialogVisible(false);
            triggerAlert('error', 'Missing Fields', 'Please fill all fields before saving.');
            return;
        }

        const jobTypePayload = {
            job_type: currentJobType.value,
            description: currentJobType.description,
            type: currentJobType.type,
        };

        const headers = { Authorization: `Bearer ${token}` };

        try {
            let response;

            if (isEditingJobType) {
                // Update existing job type
                response = await axios.put(
                    `${process.env.REACT_APP_API_BASE_URL}/api/v1/job-type/${currentJobType.id}/`,
                    jobTypePayload,
                    { headers }
                );

                setJobTypeData((prevData) =>
                    prevData.map((item) =>
                        item.id === currentJobType.id ? { ...currentJobType } : item
                    )
                );

                triggerAlert('success', 'Success', 'Job type updated successfully.');
            } else {
                // Create a new job type
                response = await axios.post(
                    `${process.env.REACT_APP_API_BASE_URL}/api/v1/job-type/`,
                    jobTypePayload,
                    { headers }
                );

                setJobTypeData((prevData) => [
                    ...prevData,
                    {
                        id: response.data.id,
                        value: response.data.job_type,
                        description: response.data.description,
                        type: response.data.type,
                    },
                ]);

                triggerAlert('success', 'Success', 'Job type created successfully.');
            }

            setJobTypeDialogVisible(false);
            handleCancelJobType();
        } catch (error) {
            //console.error('Error saving job type:', error);

            triggerAlert(
                'error',
                'Error',
                error.response?.data?.message || 'Failed to save job type. Please try again.'
            );
        }
    };


    const handleCancelJobType = () => {
        setJobTypeDialogVisible(false)
        setCurrentJobType({ id: "", value: "", description: "", type: "" })
        setIsEditingJobType(false)
    }

    const editJobTypeIcon = rowData => (
        <Button
            icon="pi pi-pencil"
            onClick={() => {
                setCurrentJobType({ ...rowData })
                setJobTypeDialogVisible(true)
                setIsEditingJobType(true)
            }}
            className="p-button-rounded p-button-info"
        />
    )
    //Delete function
    const handleDeleteJobType = async (jobTypeId) => {
        if (!jobTypeId) {
            triggerAlert('warning', 'Warning', 'Invalid job type ID.');
            return;
        }

        try {
            await axios.delete(
                `${process.env.REACT_APP_API_BASE_URL}/api/v1/job-type/${jobTypeId}/`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            setJobTypeData((prevData) => prevData.filter((jobType) => jobType.id !== jobTypeId));

            triggerAlert('success', 'Success', 'Job type deleted successfully.');
        } catch (error) {
            //console.error('Error deleting job type:', error);

            triggerAlert(
                'error',
                'Error',
                error.response?.data?.message || 'Failed to delete job type. Please try again.'
            );
        }
    };

    const deleteJobTypeIcon = rowData => (
        <Button
            icon="pi pi-trash"
            onClick={() => handleDeleteJobType(rowData.id)}
            className="p-button-rounded p-button-danger"
        />
    )

    const addNewJobType = () => {
        setCurrentJobType({ id: "", value: "", description: "", type: "" })
        setJobTypeDialogVisible(true)
        setIsEditingJobType(false)
    }

    // job type end

    ////// job function start ////////////////
    // Job type start
    const [jobFunctionData, setJobFunctionData] = useState([]);
    const [isJobFunctionDialogVisible, setJobFunctionDialogVisible] = useState(false);
    const [currentJobFunction, setCurrentJobFunction] = useState({
        id: "",
        value: "",
        description: "",
        type: "",
    });
    const [isEditingJobFunction, setIsEditingJobFunction] = useState(false);

    const jobFunctionOptions = [
        { label: "User", value: "user" },
        { label: "System", value: "system" },
    ];


    const fetchJobFunction = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/get-all-jobfunction-type/`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (response.status === 200) {
                const jobFunctions = response.data.results.map(jobFunction => ({
                    id: jobFunction.id,
                    value: jobFunction.jobfunction_type,
                    description: jobFunction.description,
                    type: jobFunction.type
                }));
                setJobFunctionData(jobFunctions);
            }
        } catch (error) {
            //console.error("Error fetching job function data:", error);
        }
    };

    //functionality for create and edit
    const handleSaveJobFunction = async () => {
        if (!currentJobFunction.value || !currentJobFunction.description || !currentJobFunction.type) {
            setJobFunctionDialogVisible(false);
            triggerAlert('error', 'Missing Fields', 'Please fill all fields before saving.');
            return;
        }

        const jobFunctionPayload = {
            jobfunction_type: currentJobFunction.value,
            description: currentJobFunction.description,
            type: currentJobFunction.type,
        };

        const headers = { Authorization: `Bearer ${token}` };

        try {
            if (isEditingJobFunction) {
                // Update existing job function
                await axios.put(
                    `${process.env.REACT_APP_API_BASE_URL}/api/v1/job-functions-type/${currentJobFunction.id}/`,
                    jobFunctionPayload,
                    { headers }
                );
                triggerAlert('success', 'Success', 'Job function updated successfully.');
                setJobFunctionData((prevData) =>
                    prevData.map((item) =>
                        item.id === currentJobFunction.id ? { ...currentJobFunction } : item
                    )
                );
            } else {
                // Create a new job function
                const response = await axios.post(
                    `${process.env.REACT_APP_API_BASE_URL}/api/v1/job-functions-type/`,
                    jobFunctionPayload,
                    { headers }
                );
                triggerAlert('success', 'Success', 'Job function created successfully.');

                setJobFunctionData((prevData) => [
                    ...prevData,
                    { id: response.data.id, ...jobFunctionPayload },
                ]);
            }
            handleCancelJobFunction();
        } catch (error) {
            //console.error("Error saving job function:", error);
            triggerAlert('error', 'Error', error.response?.data?.message || 'Failed to save degree. Please try again.');
        }
    };
    //  Reset Dialog & State
    const handleCancelJobFunction = () => {
        setJobFunctionDialogVisible(false);
        setCurrentJobFunction({ id: "", value: "", description: "", type: "" });
        setIsEditingJobFunction(false);
    };

    //  Edit Button
    const editJobFunction = rowData => (
        <Button
            icon="pi pi-pencil"
            onClick={() => {
                setCurrentJobFunction({ ...rowData });
                setJobFunctionDialogVisible(true);
                setIsEditingJobFunction(true);
            }}
            className="p-button-rounded p-button-info"
        />
    );

    //  Delete Job Function
    const handleDeleteJobFunction = async (jobFunctionId) => {
        //console.log("errrrrrrrrrrr", jobFunctionId);
        if (!jobFunctionId) {
            triggerAlert('warning', 'Warning', 'Invalid job function ID.');
            return;
        }

        try {
            await axios.delete(
                `${process.env.REACT_APP_API_BASE_URL}/api/v1/job-functions-type/${jobFunctionId}/`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                }
            );
            triggerAlert('success', 'Success', 'Job function deleted successfully.');
            setJobFunctionData((prevData) => prevData.filter((jobFunction) => jobFunction.id !== jobFunctionId));


        } catch (error) {
            //console.error('Error deleting job function:', error);

            triggerAlert(
                'error',
                'Error',
                error.response?.data?.message || 'Failed to delete job function. Please try again.'
            );
        }
    };

    //  Delete Button
    const deleteJobFunctionIcon = rowData => (
        <Button
            icon="pi pi-trash"
            onClick={() => handleDeleteJobFunction(rowData.id)}
            className="p-button-rounded p-button-danger"
        />
    );

    //  Add New Job Function
    const addNewJobFunction = () => {
        setCurrentJobFunction({ id: "", value: "", description: "", type: "" });
        setJobFunctionDialogVisible(true);
        setIsEditingJobFunction(false);
    };
    // job type end
    ///////// job functin end ////////////////

    // Department start
    const [departmentData, setDepartmentData] = useState([])
    const [isDepartmentDialogVisible, setDepartmentDialogVisible] =
        useState(false)
    const [currentDepartment, setCurrentDepartment] = useState({
        id: "",
        value: "",
        description: "",
        company: null,
        type: "",
    })
    const [isEditingDepartment, setIsEditingDepartment] = useState(false)

    const departmentTypeOptions = [
        { label: "User", value: "user" },
        { label: "System", value: "System" },
    ]

    const fetchDepartment = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/departments/`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (response.status === 200) {
                const departments = response.data.results.map(source => ({
                    id: source.department_id,
                    value: source.name,
                    description: source.description,
                    company: source.company,
                    type: source.type || 'user'
                }));
                //console.log('Fetched departments:', departments); // Debug the data
                setDepartmentData(departments);
                await fetchAllCompanies();
            }
        } catch (error) {
            //console.error('Error fetching department data:', error);
        }
    };

    const handleSaveDepartment = async () => {
        if (!currentDepartment.value || !currentDepartment.description || !currentDepartment.company || !currentDepartment.type) {
            triggerAlert("error", "Missing Fields", "Please fill all fields before saving.");
            setDepartmentDialogVisible(false);
            return;
        }

        const departmentPayload = {
            name: currentDepartment.value,
            description: currentDepartment.description,
            company_id: currentDepartment.company,
            type: currentDepartment.type,
        };

        try {
            let response;
            if (isEditingDepartment) {
                //console.log("Updating department with payload:", departmentPayload); // Debug payload
                response = await axios.put(
                    `${process.env.REACT_APP_API_BASE_URL}/api/v1/departments/${currentDepartment.id}/`,
                    departmentPayload,
                    { headers: { Authorization: `Bearer ${token}` } }
                );
                //console.log("Update response:", response); // Debug response

                // Broaden status check for success
                if ([200, 201, 204].includes(response.status)) {
                    triggerAlert("success", "Success", "Department updated successfully.");
                    setDepartmentData((prevData) =>
                        prevData.map((item) =>
                            item.id === currentDepartment.id
                                ? {
                                    ...item,
                                    value: currentDepartment.value,
                                    description: currentDepartment.description,
                                    company: currentDepartment.company,
                                    type: currentDepartment.type,
                                }
                                : item
                        )
                    );
                } else {
                    throw new Error("Unexpected response status: " + response.status);
                }
            } else {
                // Create new department (unchanged for now)
                response = await axios.post(
                    `${process.env.REACT_APP_API_BASE_URL}/api/v1/departments/`,
                    departmentPayload,
                    { headers: { Authorization: `Bearer ${token}` } }
                );
                if (response.status === 201) {
                    triggerAlert("success", "Success", "Department created successfully.");
                    const newDepartment = {
                        id: response.data.department_id || response.data.id,
                        value: response.data.name,
                        description: response.data.description,
                        company: response.data.company_id || response.data.company,
                        type: response.data.type,
                    };
                    setDepartmentData((prevData) => [...prevData, newDepartment]);
                }
            }
            handleCancelDepartment();
        } catch (error) {
            //console.error("Error saving department:", error.response || error); // Log full error details
            const errorMessage =
                error.response?.data?.error || // Use specific error from server if available
                error.response?.data?.message ||
                "Failed to save department. Please try again.";
            triggerAlert("error", "Error", errorMessage);
        }
    };


    const deleteDepartment = async (departmentId) => {
        if (!departmentId) {
            triggerAlert('warning', 'Warning', 'Invalid department ID.');
            return;
        }
        try {
            const response = await axios.delete(
                `${process.env.REACT_APP_API_BASE_URL}/api/v1/departments/${departmentId}/`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            triggerAlert('success', 'Success', 'Department deleted successfully.');
            setDepartmentData((prevData) => prevData.filter(dept => dept.id !== departmentId));

        } catch (error) {
            //console.error('Error deleting department:', error.response || error);
            triggerAlert(
                'error',
                'Error',
                error.response?.data?.message || 'Failed to delete department. Please try again.'
            );
        }
    };

    const handleCancelDepartment = () => {
        setDepartmentDialogVisible(false)
        setCurrentDepartment({ id: "", value: "", description: "", company: "", type: "" })
        setIsEditingDepartment(false)
    }

    const editDepartmentIcon = rowData => (
        <Button
            icon="pi pi-pencil"
            onClick={() => {
                setCurrentDepartment({ ...rowData })
                setDepartmentDialogVisible(true)
                setIsEditingDepartment(true)
            }}
            className="p-button-rounded p-button-info"
        />
    )

    const deleteDepartmentIcon = rowData => (
        <Button
            icon="pi pi-trash"
            onClick={() => {
                //console.log('Deleting department with ID:', rowData.id); // Debug the ID
                deleteDepartment(rowData.id);
            }}
            className="p-button-rounded p-button-danger"
        />
    );

    const addNewDepartment = () => {
        setCurrentDepartment({ id: "", value: "", description: "", company: "", type: "" })
        setDepartmentDialogVisible(true)
        setIsEditingDepartment(false)
    }
    // Department end

    // Seniority start

    const [seniorityData, setSeniorityData] = useState([])
    const [isSeniorityDialogVisible, setSeniorityDialogVisible] = useState(false)
    const [currentSeniority, setCurrentSeniority] = useState({
        id: "",
        value: "",
        description: "",
        type: "",
    })
    const [isEditingSeniority, setIsEditingSeniority] = useState(false);
    const seniorityTypeOptions = [
        { label: "user", value: "user" },
        { label: "system", value: "system" },
    ]

    // Fetch data from the API
    const fetchSeniority = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/seniority-levels/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.status === 200) {
                const levels = response.data.results.map(level => ({
                    id: level.id,
                    value: level.seniority_level,
                    description: level.description,
                    type: level.type || "user",
                }));
                setSeniorityData(levels);
            }
        } catch (error) {
            //console.error('Error fetching Seniority-Levels data:', error);
        }
    };

    const handleSaveSeniority = async () => {
        //console.log("content", currentSeniority);

        if (!currentSeniority.value || !currentSeniority.description || !currentSeniority.type) {
            setSeniorityDialogVisible(false);
            triggerAlert("error", "Missing Fields", "Please fill all fields before saving.");
            return;
        }

        const req = {
            seniority_level: currentSeniority.value,
            description: currentSeniority.description,
            type: currentSeniority.type,
        };

        try {
            let response;
            let updatedData;

            if (isEditingSeniority) {
                // Update existing seniority level
                response = await axios.put(
                    `${process.env.REACT_APP_API_BASE_URL}/api/v1/seniority-levels/${currentSeniority.id}/`,
                    req,
                    { headers: { Authorization: `Bearer ${token}` } }
                );

                if (response.status === 200) {
                    updatedData = seniorityData.map(item =>
                        item.id === currentSeniority.id ? { ...currentSeniority } : item
                    );
                    triggerAlert("success", "Success", "Seniority level updated successfully.");
                } else {
                    throw new Error(`Unexpected response status: ${response.status}`);
                }
            } else {
                // Create a new seniority level
                response = await axios.post(
                    `${process.env.REACT_APP_API_BASE_URL}/api/v1/seniority-levels/`,
                    req,
                    { headers: { Authorization: `Bearer ${token}` } }
                );

                if (response.status === 201) {
                    const newSeniority = {
                        id: response.data.id,
                        value: response.data.seniority_level,
                        description: response.data.description,
                        type: response.data.type,
                    };
                    updatedData = [...seniorityData, newSeniority];
                    triggerAlert("success", "Success", "Seniority level created successfully.");
                } else {
                    throw new Error(`Unexpected response status: ${response.status}`);
                }
            }

            setSeniorityData(updatedData);
            setSeniorityDialogVisible(false);
            handleCancelSeniority();
        } catch (error) {
            //console.error("Error saving seniority level:", error);
            triggerAlert(
                "error",
                "Error",
                error.response?.data?.message || "Failed to save seniority level. Please try again."
            );
        }
    };



    const handleCancelSeniority = () => {
        setSeniorityDialogVisible(false)
        setCurrentSeniority({ id: "", value: "", description: "", type: "" })
        setIsEditingSeniority(false)
    }

    const editSeniorityIcon = rowData => (
        <Button
            icon="pi pi-pencil"
            onClick={() => {
                setCurrentSeniority({ ...rowData })
                setSeniorityDialogVisible(true)
                setIsEditingSeniority(true)
            }}
            className="p-button-rounded p-button-info"
        />
    )

    //Delete function
    const handleDeleteSeniority = async (seniorityId) => {
        try {
            const response = await axios.delete(
                `${process.env.REACT_APP_API_BASE_URL}/api/v1/seniority-levels/${seniorityId}/`,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            if (response.status === 204) {
                setSeniorityData(prevData => prevData.filter(seniority => seniority.id !== seniorityId));
                triggerAlert('success', 'Success', 'Seniority level deleted successfully.');
            } else {
                throw new Error(`Unexpected response status: ${response.status}`);
            }
        } catch (error) {
            //console.error('Error deleting seniority:', error);
            triggerAlert('error', 'Error', 'Failed to delete seniority level. Please try again.');
        }
    };


    const deleteSeniorityIcon = rowData => (
        <Button
            icon="pi pi-trash"
            onClick={() => handleDeleteSeniority(rowData.id)}
            className="p-button-rounded p-button-danger"
        />
    )

    const addNewSeniority = () => {
        setCurrentSeniority({ id: "", value: "", description: "", type: "" })
        setSeniorityDialogVisible(true)
        setIsEditingSeniority(false)
    }

    // Seniority end

    const [specialtiesData, setSpecialtiesData] = useState([])
    const [isSpecialtiesDialogVisible, setSpecialtiesDialogVisible] =
        useState(false)
    const [currentSpecialty, setCurrentSpecialty] = useState({
        id: "",
        value: "",
        description: "",
        type: "",
    })
    const [isEditingSpecialty, setIsEditingSpecialty] = useState(false)

    const specialtiesTypeOptions = [
        { label: "User", value: "User" },
        { label: "System", value: "System" },

    ]

    const handleSaveSpecialty = () => {
        if (
            currentSpecialty.value &&
            currentSpecialty.description &&
            currentSpecialty.type
        ) {
            if (isEditingSpecialty) {
                setSpecialtiesData(prevData =>
                    prevData.map(item =>
                        item.id === currentSpecialty.id ? { ...currentSpecialty } : item
                    )
                )
            } else {
                const newSpecialty = {
                    ...currentSpecialty,
                    id: Date.now().toString(),
                }
                setSpecialtiesData(prevData => [...prevData, newSpecialty])
            }
            handleCancelSpecialty()
        } else {
            alert("Please fill all fields before saving.")
        }
    }

    const handleCancelSpecialty = () => {
        setSpecialtiesDialogVisible(false)
        setCurrentSpecialty({ id: "", value: "", description: "", type: "" })
        setIsEditingSpecialty(false)
    }

    const editSpecialtyIcon = rowData => (
        <Button
            icon="pi pi-pencil"
            onClick={() => {
                setCurrentSpecialty({ ...rowData })
                setSpecialtiesDialogVisible(true)
                setIsEditingSpecialty(true)
            }}
            className="p-button-rounded p-button-info"
        />
    )

    const deleteSpecialtyIcon = rowData => (
        <Button
            icon="pi pi-trash"
            onClick={() => {
                setSpecialtiesData(prevData =>
                    prevData.filter(item => item.id !== rowData.id)
                )
            }}
            className="p-button-rounded p-button-danger"
        />
    )

    const addNewSpecialty = () => {
        setCurrentSpecialty({ id: "", value: "", description: "", type: "" })
        setSpecialtiesDialogVisible(true)
        setIsEditingSpecialty(false)
    }

    // industry start

    const [industryData, setIndustryData] = useState([])
    const [isIndustryDialogVisible, setIndustryDialogVisible] = useState(false)
    const [currentIndustry, setCurrentIndustry] = useState({
        id: "",
        value: "",
        description: "",
        type: "",
    })
    const [isEditingIndustry, setIsEditingIndustry] = useState(false)

    const industryTypeOptions = [
        { label: "user", value: "user" },
        { label: "system", value: "system" },
    ]

    // Fetch data from the API
    const fetchIndustry = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/industry/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.status === 200) {
                const industries = response.data.results.map(industry => ({
                    id: industry.industry_id,
                    value: industry.industry_name,
                    description: industry.description,
                    type: industry.type || "user",
                }));
                //console.log("Fetched industries:", industries);
                setIndustryData(industries);
            }
        } catch (error) {
            //console.error('Error fetching industries data:', error);
        }
    };


    const handleSaveIndustry = async () => {
        if (!currentIndustry.value || !currentIndustry.description || !currentIndustry.type) {
            setIndustryDialogVisible(false)
            triggerAlert('error', 'Missing Fields', 'Please fill all fields before saving.');
            return;
        }

        const industryPayload = {
            industry_name: currentIndustry.value,
            description: currentIndustry.description,
            type: currentIndustry.type,
        };

        try {
            let response;
            if (isEditingIndustry) {
                // Update Industry
                response = await axios.put(
                    `${process.env.REACT_APP_API_BASE_URL}/api/v1/industry/${currentIndustry.id}/`,
                    industryPayload,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                if (response.status === 200) {
                    setIndustryData((prevData) =>
                        prevData.map((item) =>
                            item.id === currentIndustry.id ? { ...currentIndustry } : item
                        )
                    );
                    triggerAlert('success', 'Success', 'Work type updated successfully.');
                } else {
                    throw new Error(`Failed to update industry. Status code: ${response.status}`);
                }
            } else {
                // Create a new industry
                response = await axios.post(
                    `${process.env.REACT_APP_API_BASE_URL}/api/v1/industry/`,
                    industryPayload,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                if (response.status === 201) {
                    setIndustryData((prevData) => [
                        ...prevData,
                        {
                            id: response.data.industry_id,
                            value: response.data.industry_name,
                            description: response.data.description,
                            type: response.data.type,
                        },
                    ]);
                    triggerAlert('success', 'Success', 'Industry created successfully.');
                } else {
                    throw new Error(`Failed to create industry. Status code: ${response.status}`);
                }
            }

            setIndustryDialogVisible(false);
            handleCancelIndustry();
        } catch (error) {
            //console.error('Error saving Industry:', error);
            const errorMessage = error.response?.data?.message || `Failed to save Industry. Status code: ${error.response?.status}` || 'Please try again.';
            triggerAlert('error', 'Error', errorMessage);
        }
    };

    const handleCancelIndustry = () => {
        setIndustryDialogVisible(false)
        setCurrentIndustry({ id: "", value: "", description: "", type: "" })
        setIsEditingIndustry(false)
    }

    const editIndustryIcon = rowData => (
        <Button
            icon="pi pi-pencil"
            onClick={() => {
                setCurrentIndustry({ ...rowData })
                setIndustryDialogVisible(true)
                setIsEditingIndustry(true)
            }}
            className="p-button-rounded p-button-info"
        />
    )
    //Delete function
    const handleDeleteSIndustry = async (industryId) => {
        if (!industryId) {
            triggerAlert('warning', 'Warning', 'Invalid Industry ID.');
            return;
        }
        try {
            await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/v1/industry/${industryId}/`);
            triggerAlert('success', 'Success', 'Work type deleted successfully.');
            setIndustryData(prevData => prevData.filter(industry => industry.id !== industryId));
        } catch (error) {
            //console.error('Error deleting industry:', error);
            triggerAlert(
                'error',
                'Error',
                error.response?.data?.message || 'Failed to delete industry. Please try again.'
            );
        }
    };

    const deleteIndustryIcon = rowData => (
        <Button
            icon="pi pi-trash"
            onClick={() => handleDeleteSIndustry(rowData.id)}
            className="p-button-rounded p-button-danger"
        />
    )

    const addNewIndustry = () => {
        setCurrentIndustry({ id: "", value: "", description: "", type: "" })
        setIndustryDialogVisible(true)
        setIsEditingIndustry(false)
    }

    // industry end

    // company size start

    const [companySizeData, setCompanySizeData] = useState([])
    const [isCompanySizeDialogVisible, setCompanySizeDialogVisible] =
        useState(false)
    const [currentCompanySize, setCurrentCompanySize] = useState({
        id: "",
        value: "",
        description: "",
        type: "",
    })
    const [isEditingCompanySize, setIsEditingCompanySize] = useState(false)

    const companySizeOptions = [
        { label: "User", value: "user" },
        { label: "System", value: "system" },
    ]

    const fetchCompanySize = async () => {
        let response;
        try {
            response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/company-size/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.status === 200) {
                const sizes = response.data.results.map(size => ({
                    id: size.id,
                    value: size.company_size,
                    description: size.description,
                    type: size.type || 'user', // Assuming 'user' as default type if not provided
                }));
                setCompanySizeData(sizes);
            }
        } catch (error) {
            //console.error("Error fetching media list:", error);
        }
    }


    const handleSaveCompanySize = async (id) => {
        if (!currentCompanySize.value || !currentCompanySize.description || !currentCompanySize.type) {
            setCompanySizeDialogVisible(false);
            triggerAlert("error", "Missing Fields", "Please fill all fields before saving.");
            return;
        }

        const companySizePayload = {
            company_size: parseInt(currentCompanySize.value, 10),
            description: currentCompanySize.description,
            type: currentCompanySize.type,
        };

        try {
            let response;
            if (isEditingCompanySize) {
                response = await axios.put(
                    `${process.env.REACT_APP_API_BASE_URL}/api/v1/company-size/${currentCompanySize.id}/`,
                    companySizePayload,
                    { headers: { Authorization: `Bearer ${token}` } }
                );

                if (response.status === 200) {
                    setCompanySizeData((prevData) =>
                        prevData.map((item) =>
                            item.id === currentCompanySize.id ? { ...currentCompanySize } : item
                        )
                    );
                    triggerAlert('success', 'Success', 'Company Size updated successfully.');
                } else {
                    throw new Error(`Failed to update Company Size. Status code: ${response.status}`);
                }
            } else {
                // Create a new Company size
                response = await axios.post(
                    `${process.env.REACT_APP_API_BASE_URL}/api/v1/company-size/`,
                    companySizePayload,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                if (response.status === 201) {
                    setCompanySizeData((prevData) => [
                        ...prevData,
                        {
                            id: response.data.id,
                            value: response.data.compnay_size,
                            description: response.data.description,
                            type: response.data.type,
                        },
                    ]);
                    triggerAlert('success', 'Success', 'Company size created successfully.');
                } else {
                    throw new Error(`Failed to Company size. Status code: ${response.status}`);
                }
            }

            setCompanySizeDialogVisible(false);
            handleCancelCompanySize();
        } catch (error) {
            //console.error('Error saving Company size:', error);
            const errorMessage = error.response?.data?.message || `Failed to save Company size. Status code: ${error.response?.status}` || 'Please try again.';
            triggerAlert('error', 'Error', errorMessage);
        }
    };



    const handleCancelCompanySize = () => {
        setCompanySizeDialogVisible(false)
        setCurrentCompanySize({ id: "", value: "", description: "", type: "" })
        setIsEditingCompanySize(false)
    }

    const editCompanySizeIcon = rowData => (
        <Button
            icon="pi pi-pencil"
            onClick={() => {
                setCurrentCompanySize({ ...rowData })
                setCompanySizeDialogVisible(true)
                setIsEditingCompanySize(true)
            }}
            className="p-button-rounded p-button-info"
        />
    )

    const deleteCompanySize = async (id) => {
        if (!id) {
            triggerAlert('warning', 'Warning', 'Invalid Company size ID.');
            return;
        }
        try {
            const response = await axios.delete(
                `${process.env.REACT_APP_API_BASE_URL}/api/v1/company-size/${id}/`,
                {
                    headers: { Authorization: `Bearer ${token}` }, // Added authorization header
                }
            );

            if (response.status === 204) {
                setCompanySizeData(prevData => prevData.filter(item => item.id !== id));
                triggerAlert("success", "Success", "Company size deleted successfully.");
            }
        } catch (error) {
            //console.error("Error deleting company size:", error);
            triggerAlert("error", "Error", "Failed to delete company size. Please try again.");
        }
    };



    const deleteCompanySizeIcon = rowData => (
        <Button
            icon="pi pi-trash"
            onClick={() => deleteCompanySize(rowData.id)}
            className="p-button-rounded p-button-danger"
        />
    )

    const addNewCompanySize = () => {
        setCurrentCompanySize({ id: "", value: "", description: "", type: "" })
        setCompanySizeDialogVisible(true)
        setIsEditingCompanySize(false)
    }

    // company size end

    // Schedule type start

    const fetchScheduleType = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/api/v1/schedule-type/`
            );
            if (response.status === 200) {
                const scheduled = response.data.results.map((schedule) => ({
                    id: schedule.id,
                    value: schedule.schedule_type,
                    description: schedule.description,
                    type: schedule.type || "user",
                }));
                setScheduleTypeData(scheduled);
            }
        } catch (error) {
            //console.error("Error fetching schedule data:", error);
        }
    };

    const [scheduleTypeData, setScheduleTypeData] = useState([])
    const [isScheduleTypeDialogVisible, setScheduleTypeDialogVisible] =
        useState(false)
    const [currentScheduleType, setCurrentScheduleType] = useState({
        id: "",
        value: "",
        description: "",
        type: "",
    })
    const [isEditingScheduleType, setIsEditingScheduleType] = useState(false)

    const scheduleTypeOptions = [
        { label: "User", value: "user" },
        { label: "System", value: "system" },
    ]

    const handleSaveScheduleType = async () => {
        if (!currentScheduleType.value || !currentScheduleType.description || !currentScheduleType.type) {
            setScheduleTypeDialogVisible(false);
            triggerAlert("error", "Missing Fields", "Please fill all fields before saving.");
            return;
        }
        const scheduleTypePayload = {
            schedule_type: currentScheduleType.value,
            description: currentScheduleType.description,
            type: currentScheduleType.type,
        };

        try {
            let response;
            if (isEditingScheduleType) {
                response = await axios.put(
                    `${process.env.REACT_APP_API_BASE_URL}/api/v1/schedule-type/${currentScheduleType.id}/`,
                    scheduleTypePayload,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
                if (response.status === 200) {
                    setScheduleTypeData((prevData) =>
                        prevData.map((item) =>
                            item.id === currentScheduleType.id ? { ...currentScheduleType } : item
                        )
                    );
                    triggerAlert('success', 'Success', 'Schedule type updated successfully.');
                } else {
                    throw new Error(`Failed to update schedule. Status code: ${response.status}`);
                }
            } else {
                // Create a new schedule
                response = await axios.post(
                    `${process.env.REACT_APP_API_BASE_URL}/api/v1/schedule-type/`,
                    scheduleTypePayload,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                if (response.status === 201) {
                    setScheduleTypeData((prevData) => [
                        ...prevData,
                        {
                            id: response.data.id,
                            value: response.data.schedule_type,
                            description: response.data.description,
                            type: response.data.type,
                        },
                    ]);
                    triggerAlert('success', 'Success', 'Schedule type created successfully.');
                } else {
                    throw new Error(`Failed to create schedule type. Status code: ${response.status}`);
                }
            }
            setScheduleTypeDialogVisible(false);
            handleCancelScheduleType();
        } catch (error) {
            //console.error('Error saving schedule type:', error);
            const errorMessage = error.response?.data?.message || `Failed to save schedule type. Status code: ${error.response?.status}` || 'Please try again.';
            triggerAlert('error', 'Error', errorMessage);
        }
    };


    const handleCancelScheduleType = () => {
        setScheduleTypeDialogVisible(false)
        setCurrentScheduleType({ id: "", value: "", description: "", type: "" })
        setIsEditingScheduleType(false)
    }

    const editScheduleTypeIcon = rowData => (
        <Button
            icon="pi pi-pencil"
            onClick={() => {
                setCurrentScheduleType({ ...rowData })
                setScheduleTypeDialogVisible(true)
                setIsEditingScheduleType(true)
            }}
            className="p-button-rounded p-button-info"
        />
    )

    //Delete function
    const handleDeleteScheduleType = async (scheduleId) => {
        if (!scheduleId) {
            triggerAlert('warning', 'Warning', 'Invalid Schedule Type ID.');
            return;
        }
        try {
            await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/v1/schedule-type/${scheduleId}/`);
            triggerAlert('success', 'Success', 'Schedule type deleted successfully.');
            setScheduleTypeData(prevData => prevData.filter(schedule => schedule.id !== scheduleId));
        } catch (error) {
            //console.error('Error deleting Schedule type:', error);
            triggerAlert(
                'error',
                'Error',
                error.response?.data?.message || 'Failed to delete Schedule. Please try again.'
            );
        }
    };
    const deleteScheduleTypeIcon = rowData => (
        <Button
            icon="pi pi-trash"
            onClick={() => handleDeleteScheduleType(rowData.id)}
            className="p-button-rounded p-button-danger"
        />
    )

    const addNewScheduleType = () => {
        setCurrentScheduleType({ id: "", value: "", description: "", type: "" })
        setScheduleTypeDialogVisible(true)
        setIsEditingScheduleType(false)
    }

    // schedle typ end

    // Schedule sub-type


    const [scheduleSubTypeData, setScheduleSubTypeData] = useState([]);
    const [isScheduleSubTypeDialogVisible, setIsScheduleSubTypeDialogVisible] =
        useState(false);
    const [isEditingScheduleSubType, setIsEditingScheduleSubType] =
        useState(false);
    const [currentScheduleSubType, setCurrentScheduleSubType] = useState({
        id: "",
        value: "",
        description: "",
        type: "",
    });

    const scheduleSubTypeOptions = [
        { label: "User", value: "user" },
        { label: "System", value: "system" },
    ];


    // Fetch Schedule Sub-Type Data
    const fetchScheduleSubType = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/schedule-sub-type/`);
            if (response.status === 200) {
                const subTypes = response.data.results.map((subType) => ({
                    id: subType.id,
                    value: subType.schedule_subtype,
                    description: subType.description,
                    type: subType.type || "user",
                }));
                setScheduleSubTypeData(subTypes);
            }
        } catch (error) {
            //console.error("Error fetching schedule sub-type data:", error);
        }
    };

    // Save (Create or Update) Schedule Sub-Type
    const handleSaveScheduleSubType = async () => {
        if (!currentScheduleSubType.value || !currentScheduleSubType.description || !currentScheduleSubType.type) {
            setIsScheduleSubTypeDialogVisible(false);
            triggerAlert("error", "Missing Fields", "Please fill all fields before saving.");
            return;
        }

        const scheduleSubTypePayload = {
            schedule_subtype: currentScheduleSubType.value,
            description: currentScheduleSubType.description,
            type: currentScheduleSubType.type,
        };

        try {
            let response;
            if (isEditingScheduleSubType) {
                // Updating existing schedule subtype
                response = await axios.put(
                    `${process.env.REACT_APP_API_BASE_URL}/api/v1/schedule-sub-type/${currentScheduleSubType.id}/`,
                    scheduleSubTypePayload,
                    { headers: { Authorization: `Bearer ${token}` } }
                );
                setScheduleSubTypeData((prevData) =>
                    prevData.map((item) =>
                        item.id === currentScheduleSubType.id ? { ...response.data } : item
                    )
                );
                triggerAlert("success", "Success", "Schedule subtype updated successfully.");
            } else {
                // Creating new schedule subtype
                response = await axios.post(
                    `${process.env.REACT_APP_API_BASE_URL}/api/v1/schedule-sub-type/`,
                    scheduleSubTypePayload,
                    { headers: { Authorization: `Bearer ${token}` } }
                );
                if (response.status === 201) {
                    setScheduleSubTypeData((prevData) => [
                        ...prevData,
                        {
                            id: response.data.id,
                            value: response.data.schedule_subtype,
                            description: response.data.description,
                            type: response.data.type,
                        },
                    ]);
                    triggerAlert('success', 'Success', 'Schedule subtype created successfully.');
                } else {
                    throw new Error(`Failed to create schedule subtype. Status code: ${response.status}`);
                }
            }
            setIsScheduleSubTypeDialogVisible(false);
            handleCancelScheduleSubType();
        } catch (error) {
            //console.error("Error saving schedule sub-type:", error);
            triggerAlert("error", "Error", error.response?.data?.message || "Failed to save schedule sub-type. Please try again.");
        }
    };


    // Delete Schedule Sub-Type
    const handleDeleteScheduleSubType = async (id) => {
        if (!id) {
            triggerAlert('warning', 'Warning', 'Invalid Schedule Type ID.');
            return;
        }
        try {
            await axios.delete(
                `${process.env.REACT_APP_API_BASE_URL}/api/v1/schedule-sub-type/${id}/`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            triggerAlert("success", "Success", "Schedule sub-type deleted successfully.");
            setScheduleSubTypeData(prevData => prevData.filter(item => item.id !== id));

        } catch (error) {
            //console.error("Error deleting schedule sub-type:", error);
            triggerAlert(
                "error",
                "Error",
                error.response?.data?.message || "Failed to delete schedule sub-type. Please try again."
            );
        }
    };



    const handleCancelScheduleSubType = () => {
        setIsScheduleSubTypeDialogVisible(false);
        setCurrentScheduleSubType({ id: "", value: "", description: "", type: "" });
        setIsEditingScheduleSubType(false);
    };

    const addNewScheduleSubType = () => {
        setIsEditingScheduleSubType(false);
        setCurrentScheduleSubType({ id: "", value: "", description: "", type: "" });
        setIsScheduleSubTypeDialogVisible(true);
    };

    const editScheduleSubTypeIcon = (rowData) => (
        <Button
            icon="pi pi-pencil"
            className="p-button-rounded p-button-text"
            onClick={() => {
                setIsEditingScheduleSubType(true);
                setCurrentScheduleSubType(rowData);
                setIsScheduleSubTypeDialogVisible(true);
            }}
        />
    );

    const deleteScheduleSubTypeIcon = (rowData) => (
        <Button
            icon="pi pi-trash"
            className="p-button-rounded p-button-text p-button-danger"
            onClick={() => handleDeleteScheduleSubType(rowData.id)}
        />
    );


    // schedule sub-type

    // Received System start

    const [receivedSystemData, setReceivedSystemData] = useState([])
    const [isReceivedSystemDialogVisible, setReceivedSystemDialogVisible] =
        useState(false)
    const [currentReceivedSystem, setCurrentReceivedSystem] = useState({
        id: "",
        value: "",
        description: "",
        type: "",
    })
    const [isEditingReceivedSystem, setIsEditingReceivedSystem] = useState(false)

    const receivedSystemOptions = [
        { label: "User", value: "User" },
        { label: "System", value: "System" },
    ]


    const handleCancelReceivedSystem = () => {
        setReceivedSystemDialogVisible(false)
        setCurrentReceivedSystem({ id: "", value: "", description: "", type: "" })
        setIsEditingReceivedSystem(false)
    }

  
    const [potentialSystemData, setPotentialSystemData] = useState([])
    const [isPotentialSystemDialogVisible, setPotentialSystemDialogVisible] =
        useState(false)
    const [currentPotentialSystem, setCurrentPotentialSystem] = useState({
        id: "",
        value: "",
        description: "",
        type: "",
    })
    const [isEditingPotentialSystem, setIsEditingPotentialSystem] =        useState(false)


    const handleCancelPotentialSystem = () => {
        setPotentialSystemDialogVisible(false)
        setCurrentPotentialSystem({ id: "", value: "", description: "", type: "" })
        setIsEditingPotentialSystem(false)
    }

    const [submittedSystemData, setSubmittedSystemData] = useState([])
    const [isSubmittedSystemDialogVisible, setSubmittedSystemDialogVisible] =
        useState(false)
    const [currentSubmittedSystem, setCurrentSubmittedSystem] = useState({
        id: "",
        value: "",
        description: "",
        type: "",
    })
    const [isEditingSubmittedSystem, setIsEditingSubmittedSystem] = useState(false)
    const handleCancelSubmittedSystem = () => {
        setSubmittedSystemDialogVisible(false)
        setCurrentSubmittedSystem({ id: "", value: "", description: "", type: "" })
        setIsEditingSubmittedSystem(false)
    }
    const [userTableData, setUserTableData] = useState([])
    const [isUserDialogVisible, setUserDialogVisible] = useState(false)
    const [selectedUserRecord, setSelectedUserRecord] = useState({
        id: "",
        value: "",
        description: "",
        type: "",
    })
    const [isEditUserMode, setEditUserMode] = useState(false)


    const handleCancelUserDialog = () => {
        setUserDialogVisible(false)
        setSelectedUserRecord({ id: "", value: "", description: "", type: "" })
        setEditUserMode(false)
    }

    const [shortlistedData, setShortlistedData] = useState([])
    const [isShortlistedDialogVisible, setShortlistedDialogVisible] =
        useState(false)
    const [currentShortlisted, setCurrentShortlisted] = useState({
        id: "",
        value: "",
        description: "",
        type: "",
    })
    const [isEditShortlistedMode, setEditShortlistedMode] = useState(false)
    const handleCancelShortlisted = () => {
        setShortlistedDialogVisible(false)
        setCurrentShortlisted({ id: "", value: "", description: "", type: "" })
        setEditShortlistedMode(false)
    }
    const [interviewData, setInterviewData] = useState([])
    const [isInterviewDialogVisible, setInterviewDialogVisible] = useState(false)
    const [currentInterview, setCurrentInterview] = useState({
        id: "",
        value: "",
        description: "",
        type: "",
    })
    const [isEditInterviewMode, setEditInterviewMode] = useState(false)

    const interviewTypeOptions = [
        { label: "User", value: "User" },
        { label: "System", value: "System" },
    ]



    const handleCancelInterview = () => {
        setInterviewDialogVisible(false)
        setCurrentInterview({ id: "", value: "", description: "", type: "" })
        setEditInterviewMode(false)
    }

    const [verificationData, setVerificationData] = useState([])
    const [isVerificationDialogVisible, setVerificationDialogVisible] =
        useState(false)
    const [currentVerification, setCurrentVerification] = useState({
        id: "",
        value: "",
        description: "",
        type: "",
    })
    const [isEditVerificationMode, setEditVerificationMode] = useState(false)

    const handleCancelVerification = () => {
        setVerificationDialogVisible(false)
        setCurrentVerification({ id: "", value: "", description: "", type: "" })
        setEditVerificationMode(false)
    }

    const [selectedData, setSelectedData] = useState([])
    const [isSelectedDialogVisible, setSelectedDialogVisible] = useState(false)
    const [currentSelected, setCurrentSelected] = useState({
        id: "",
        value: "",
        description: "",
        category: "",
    })
    const [isEditSelectedMode, setEditSelectedMode] = useState(false)

    const selectedCategoryOptions = [
        { label: "User", value: "User" },
        { label: "System", value: "System" },
    ]


    const handleCancelSelected = () => {
        setSelectedDialogVisible(false)
        setCurrentSelected({ id: "", value: "", description: "", category: "" })
        setEditSelectedMode(false)
    }



    // Rejected start

    const [rejectedData, setRejectedData] = useState([])
    const [isRejectedDialogVisible, setRejectedDialogVisible] = useState(false)
    const [currentRejected, setCurrentRejected] = useState({
        id: "",
        value: "",
        description: "",
        reason: "",
    })
    const [isEditRejectedMode, setEditRejectedMode] = useState(false)


    const handleCancelRejected = () => {
        setRejectedDialogVisible(false)
        setCurrentRejected({ id: "", value: "", description: "", reason: "" })
        setEditRejectedMode(false)
    }


    const [offeredData, setOfferedData] = useState([])
    const [isOfferedDialogVisible, setOfferedDialogVisible] = useState(false)
    const [currentOffered, setCurrentOffered] = useState({
        id: "",
        value: "",
        description: "",
        type: "",
    })
    const [isEditingOffered, setIsEditingOffered] = useState(false)
    const handleCancelOffered = () => {
        setOfferedDialogVisible(false)
        setCurrentOffered({ id: "", value: "", description: "", type: "" })
        setIsEditingOffered(false)
    }

    const [currentOfferAccepted, setCurrentOfferAccepted] = useState({ id: "", value: "", description: "", type: "", })
    const [isEditingOfferAccepted, setIsEditingOfferAccepted] = useState(false)

    const handleCancelOfferAccepted = () => {
        setOfferAcceptedDialogVisible(false)
        setCurrentOfferAccepted({ id: "", value: "", description: "", type: "" })
        setIsEditingOfferAccepted(false)
    }
    const [currentOfferRejected, setCurrentOfferRejected] = useState({ id: "", value: "", description: "", type: "", })
    const [isEditingOfferRejected, setIsEditingOfferRejected] = useState(false)
    const handleCancelOfferRejected = () => {
        setOfferRejectedDialogVisible(false)
        setCurrentOfferRejected({ id: "", value: "", description: "", type: "" })
        setIsEditingOfferRejected(false)
    }
    const [currentOfferReleased, setCurrentOfferReleased] = useState({ id: "", value: "", description: "", type: "", })
    const [isEditingOfferReleased, setIsEditingOfferReleased] = useState(false)
    const handleCancelOfferReleased = () => {
        setOfferReleasedDialogVisible(false)
        setCurrentOfferReleased({ id: "", value: "", description: "", type: "" })
        setIsEditingOfferReleased(false)
    }

    const [currentOnboarding, setCurrentOnboarding] = useState({ id: "", value: "", description: "", type: "", })
    const [isEditingOnboarding, setIsEditingOnboarding] = useState(false)

    const handleCancelOnboarding = () => {
        setOnboardingDialogVisible(false)
        setCurrentOnboarding({ id: "", value: "", description: "", type: "" })
        setIsEditingOnboarding(false)
    }

    const handleCancelJoined = () => {
        setJoinedDialogVisible(false)
        setCurrentJoined({ id: "", value: "", description: "", type: "" })
        setIsEditingJoined(false)
    }

    // categories start
    const fetchCategories = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/categories/`);
            if (response.status === 200) {
                const categories = response.data.results.map(category => ({
                    id: category.category_id,
                    name: category.name,
                    description: category.description,
                    parentCategory: category.parent_category,
                }));
                setNodes(categories);
            }
        } catch (error) {
            //console.error('Error fetching categories:', error);
        }
    };

    const [nodes, setNodes] = useState([]);
    const [selectedNodeKey, setSelectedNodeKey] = useState(null);

    // Function to create a new node
    const createNode = (parentId = null) => {
        const newNode = {
            key: Date.now().toString(),
            label: '',
            parentId,
            children: []
        };

        if (!parentId) {
            setNodes([...nodes, newNode]);
        } else {
            const updateNodes = (nodesList) => {
                return nodesList.map(node => {
                    if (node.key === parentId) {
                        return {
                            ...node,
                            children: [...(node.children || []), newNode]
                        };
                    }
                    if (node.children && node.children.length > 0) {
                        return {
                            ...node,
                            children: updateNodes(node.children)
                        };
                    }
                    return node;
                });
            };
            setNodes(updateNodes(nodes));
        }
    };

    // Function to update node label
    const updateNodeLabel = (id, newLabel) => {
        const updateNodes = (nodesList) => {
            return nodesList.map(node => {
                if (node.key === id) {
                    return { ...node, label: newLabel };
                }
                if (node.children && node.children.length > 0) {
                    return {
                        ...node,
                        children: updateNodes(node.children)
                    };
                }
                return node;
            });
        };
        setNodes(updateNodes(nodes));
    };

    // Function to delete a node
    const deleteNode = (id) => {
        const removeNode = (nodesList) => {
            return nodesList.filter(node => {
                if (node.key === id) {
                    return false;
                }
                if (node.children && node.children.length > 0) {
                    node.children = removeNode(node.children);
                }
                return true;
            });
        };
        setNodes(removeNode(nodes));
    };

    // Recursive component to render the tree structure
    const RenderNode = ({ node }) => {
        const [localLabel, setLocalLabel] = useState(node.label);

        const handleInputChange = (e) => {
            setLocalLabel(e.target.value); // Update local state
        };

        const handleInputBlur = () => {
            if (localLabel !== node.label) {
                updateNodeLabel(node.key, localLabel); // Update global state on blur
            }
        };

        return (
            <div className="ml-4">
                <div className="flex items-center gap-2 my-2">
                    <InputText
                        value={localLabel}
                        onChange={handleInputChange}
                        onBlur={handleInputBlur}
                        placeholder="Enter node label"
                        className="p-inputtext"
                    />
                    <Button
                        icon="pi pi-plus"
                        className="p-button-rounded p-button-success p-button-text"
                        onClick={() => createNode(node.key)}
                        tooltip="Add child node"
                    />
                    <Button
                        icon="pi pi-trash"
                        className="p-button-rounded p-button-danger p-button-text"
                        onClick={() => deleteNode(node.key)}
                        tooltip="Delete node"
                    />
                </div>
                {node.children && node.children.length > 0 && (
                    <div className="ml-4">
                        {node.children.map((childNode) => (
                            <RenderNode key={childNode.key} node={childNode} />
                        ))}
                    </div>
                )}
            </div>
        );
    };


    // Categories end

    // Groups start

    const [categoryNodes, setCategoryNodes] = useState([]);
    const [selectedCategoryKey, setSelectedCategoryKey] = useState(null);

    // Function to create a new category
    const createCategory = (parentCategoryId = null) => {
        const newCategory = {
            key: Date.now().toString(),
            label: '',
            parentCategoryId,
            children: []
        };

        if (!parentCategoryId) {
            setCategoryNodes([...categoryNodes, newCategory]);
        } else {
            const updateCategories = (categoriesList) => {
                return categoriesList.map(category => {
                    if (category.key === parentCategoryId) {
                        return {
                            ...category,
                            children: [...(category.children || []), newCategory]
                        };
                    }
                    if (category.children && category.children.length > 0) {
                        return {
                            ...category,
                            children: updateCategories(category.children)
                        };
                    }
                    return category;
                });
            };
            setCategoryNodes(updateCategories(categoryNodes));
        }
    };

    // Function to update category label
    const updateCategoryLabel = (id, newLabel) => {
        const updateCategories = (categoriesList) => {
            return categoriesList.map(category => {
                if (category.key === id) {
                    return { ...category, label: newLabel };
                }
                if (category.children && category.children.length > 0) {
                    return {
                        ...category,
                        children: updateCategories(category.children)
                    };
                }
                return category;
            });
        };
        setCategoryNodes(updateCategories(categoryNodes));
    };

    // Function to delete a category
    const deleteCategory = (id) => {
        const removeCategory = (categoriesList) => {
            return categoriesList.filter(category => {
                if (category.key === id) {
                    return false;
                }
                if (category.children && category.children.length > 0) {
                    category.children = removeCategory(category.children);
                }
                return true;
            });
        };
        setCategoryNodes(removeCategory(categoryNodes));
    };

    // Recursive component to render the category structure
    const RenderCategory = ({ category }) => {
        const [localCategoryLabel, setLocalCategoryLabel] = useState(category.label);

        const handleInputChange = (e) => {
            setLocalCategoryLabel(e.target.value); // Update local state
        };

        const handleInputBlur = () => {
            if (localCategoryLabel !== category.label) {
                updateCategoryLabel(category.key, localCategoryLabel); // Update global state on blur
            }
        };

        return (
            <div className="ml-4">
                <div className="flex items-center gap-2 my-2">
                    <InputText
                        value={localCategoryLabel}
                        onChange={handleInputChange}
                        onBlur={handleInputBlur}
                        placeholder="Enter category label"
                        className="p-inputtext"
                    />
                    <Button
                        icon="pi pi-plus"
                        className="p-button-rounded p-button-success p-button-text"
                        onClick={() => createCategory(category.key)}
                        tooltip="Add child category"
                    />
                    <Button
                        icon="pi pi-trash"
                        className="p-button-rounded p-button-danger p-button-text"
                        onClick={() => deleteCategory(category.key)}
                        tooltip="Delete category"
                    />
                </div>
                {category.children && category.children.length > 0 && (
                    <div className="ml-4">
                        {category.children.map((childCategory) => (
                            <RenderCategory key={childCategory.key} category={childCategory} />
                        ))}
                    </div>
                )}
            </div>
        );
    };

    // Group end

    /////////////////////////////////////////////// Sahitis Code /////////////////////////////////////////////////////////////// 
    const getaddCountries = async () => {
        try {
            const response = await axios.get(`/api/v1/get-all-countries/`, {});
            const transformedData = response.data.results.map((Countries) => ({
                name: Countries.name,
                id: Countries.country_id,
            }));
            setAddCountries(transformedData);
            // //console.log(transformedData)

        }
        catch (error) {
        }
    };
    const getaddStates = async (countryId) => {
        try {
            const response = await axios.get(`/api/v1/get-all-states/?country_id=${countryId}`, {});
            const transformedData = response.data.results.map((city) => ({
                name: city.name,
                id: city.state_id,
            }));
            setAddStates(transformedData);

        }
        catch (error) {
        }
    };
    const getaddCities = async (stateId) => {
        try {
            const response = await axios.get(`/api/v1/get-all-cities/?state_id=${stateId}`, {});
            const transformedData = response.data.results.map((city) => ({
                name: city.name,
                id: city.city_id,
            }));
            setAddCities(transformedData);

        }
        catch (error) {
        }
    };

    const fetchUserRoles = async () => {
        try {
            const response = await axios.get(`api/v1/get-all-roles/`)
            if (response?.status === 200) {
                setUserRoles(response?.data?.results)

            }
        }
        catch (error) {
            //console.log('error occured ', error.message)
        }
    }
    const fetchAllCompanies = async () => {
        try {
            const response = await axios.get(`api/v1/get-all-companies/`)
            if (response?.status === 200) {
                setAllCompanies(response?.data?.results)

            }
        }
        catch (error) {
            //console.log('error occured ', error.message)
        }
    }
    const fetchAllDepartments = async () => {
        try {
            const response = await axios.get(`api/v1/get-all-departments/`)
            if (response?.status === 200) {
                setAllDepartments(response?.data?.results)

            }
        }
        catch (error) {
            //console.log('error occured ', error.message)
        }
    }

    // Handle edit
    const handleEditUser = (rowData) => {

        console.log(rowData)
        setValue('user_id', rowData.user_id);
        setValue('email', rowData.email);
        setValue('password', rowData.password);
        setValue("role_id", rowData.role_id, { shouldValidate: true }); // Ensure validation runs
        setValue('company', rowData.company);
        setValue('first_name', rowData.first_name);
        setValue('middle_name', rowData.middle_name);
        setValue('last_name', rowData.last_name);
        setValue('phone_number', rowData.phone_number);
        setValue('job_title', rowData.job_title);
        setValue('department', rowData.department);
        setValue('category', rowData.category);
        setValue('group', rowData.group);
        setStreet1(rowData.street_address);
        setStreet2(rowData.street_address_line_2);
        setSelectedLabel1(rowData.label);
        setPostalCode(rowData.pincode);

        setValue('label', rowData.label);
        setIsEditMode(rowData?.id)
        setFormVisible(true)

    }


    const addNewUser = async (data) => {
        setIsLoading(true);
        try {
            const response = await axios.post(`/api/v1/users/`, data);
            //console.log("response", response)
            if (response.status === 201) {
                setIsLoading(false);
                fetchUserManagementDetails();
                resetForm();
            }
        } catch (error) {
            //console.error(error);
            setIsLoading(false);
        }
    }
    const editNewUser = async (id, data) => {
        setIsLoading(true);
        try {
            const response = await axios.put(`/api/v1/users/${id}`, data);
            //console.log("response", response)
            if (response.status === 201) {
                setIsLoading(false);
                fetchUserManagementDetails();
                resetForm();
            }
        } catch (error) {
            //console.error(error);
            setIsLoading(false);
        }
    }
    // Handle form submit (Add or Edit user)
    const handleFormSubmit = (data) => {
        //console.log("data", data);
        data.street_address = street1;
        data.street_address_line_2 = street2;
        data.pincode = postalCode;
        data.label = selectedLabel1?.name;
        data.category = data.category?.id;
        if (isEditMode) {
            // Update existing user
            editNewUser(isEditMode, data);
        } else {
            // Add new user

            addNewUser(data)
        }
        // resetForm()
    }
    // Handle delete
    const handleDeleteUser = id => {
        ConfirmationAlert('You want to continue?', 'Continue', async () => {
            try {
                const response = await axios.delete(`/api/v1/users/${id}/`, {

                });
                if (response.status === 200) {
                    const responseData = response.data.results;
                    fetchUserManagementDetails();
                }

            } catch (error) {

            }
        })
    }

    const getcategoriesitem = async () => {

        try {
            const response = await axios.get(`/api/v1/get-all-categories/`, {

            });

            if (response.data && response.data.results) {
                const transformedData = response.data.results.map((Categories) => ({
                    name: Categories.name,
                    id: Categories.category_id,
                }));
                setcategoriesitem(transformedData);
            }
        } catch (error) {

        }
    };

    const getgroupsitemsub = async (category_ids) => {

        try {
            const response = await axios.get(`/api/v1/get-all-groups/?category_id=${category_ids}`, {

            });
            if (response.data && response.data.results) {
                const transformedDatagroup = response.data.results.map((Groups) => ({
                    name: Groups.name,
                    id: Groups.group_id,
                }));
                setgroupitem(transformedDatagroup);
            }

        } catch (error) {

        }
    };
    const fetchUserManagementDetails = async () => {
        try {
            const response = await axios.get(`/api/v1/users/`, {

            });
            if (response.status === 200) {
                const responseData = response.data.results;
                setUserList(responseData);
            }

        } catch (error) {

        }
    }
    useEffect(() => {
        if (selectedCategoryKey) {
            getgroupsitemsub(selectedCategoryKey);
        }
    }, [selectedCategoryKey]);
    useEffect(() => {
        getaddCountries()
        getcategoriesitem()
        fetchUserManagementDetails();
    }, [])
    useEffect(() => {
        if (formVisible) {
            fetchUserRoles();
            fetchAllCompanies();
            fetchAllDepartments();
        }

    }, [formVisible])
    useEffect(() => {
        if (selectedCountry) {
            getaddStates(selectedCountry.id);
        }
    }, [selectedCountry]);

    useEffect(() => {
        if (selectedState) {
            getaddCities(selectedState.id);
        }
    }, [selectedState]);
    /////////////////////////////////////////////////////naveen pss////////////////////////////

    const [modulepermissions, setmodulepermissions] = useState([]);

    const [roleslist, setroleslist] = useState([]);
    const { register: register1, formState: { errors: errors1 }, handleSubmit: handleSubmit1, getValues: getValues1, setValue: setValue1, trigger: trigger1, reset: reset1, } = useForm({ mode: "onBlur" });
    const [selectedParent, setSelectedParent] = useState([]);
    const [selectedChildren, setSelectedChildren] = useState([]);
    const [actions, setActions] = useState({});
    const [totalRecords, setTotalRecords] = useState(0);
    const [loading, setLoading] = useState(false);
    const [lazyParams, setLazyParams] = useState({ page: 0, rows: 10 });
    const [smShow, setSmShow] = useState(false)
    const [successAlert, setSuccessAlert] = useState(false);
    const [deleteRowId, setDeleteRowID] = useState(null)
    const [isEdited, setisEdited] = useState(false);
    const [editId, setEditId] = useState(null);
    const [disable, setDisable] = useState(false);

    const handleShowAddUser = () => {
        fetchUserRoles();
        fetchAllCompanies();
        fetchAllDepartments();
        setFormVisible(true)

    }

    useEffect(() => {
        getAllrolesList();
    }, [lazyParams]);

    const onPageChange = (event) => {
        setLazyParams({ page: event.page, rows: event.rows });
    };

    const getAllrolesList = async () => {
        try {
            const response = await axios.get(`/api/v1/roles/?page=${lazyParams.page + 1}&size=${lazyParams.rows}`, {});
            if (response.data && response.data.results) {

                setroleslist(response.data.results);
                setTotalRecords(response.data.count || 0)
            }
        } catch (error) {
        }
    };

    const getAllSublist = async () => {
        try {
            const response = await axios.get(`/api/v1/get-menu-data/`, {});
            if (response.data && response.data.results) {
                setmodulepermissions(response.data.results);
            }
        } catch (error) {
        }
    };



    const getAllSublistupdate = async (id) => {
        try {
            const response = await axios.get(`/api/v1/roles/${id}/`, {});
            if (response.data) {
                let results = response.data;

                setValue1("roleName", results.role_data.role_name)
                setValue1("createdatesrole", moment(results.role_data.created_at).format("YYYY-MM-DD"))
                let permissions = results.permission_data || [];
                let parentPermissions = new Set();
                let childPermissions = new Set();
                let actionPermissions = {};

                permissions.forEach(permission => {
                    let parentIds = permission.parent_id ? permission.parent_id.split(',').map(Number) : [];
                    let childIds = permission.child_id ? permission.child_id.split(',').map(Number) : [];

                    parentIds.forEach(pid => parentPermissions.add(pid));
                    childIds.forEach(cid => childPermissions.add(cid));

                    childIds.forEach(cid => {
                        actionPermissions[cid] = {
                            add: permission.add === cid.toString(),
                            edit: permission.edit === cid.toString(),
                            delete: permission.delete === cid.toString(),
                            view: permission.view === cid.toString(),
                        };
                    });
                });

                setSelectedParent(Array.from(parentPermissions));
                setSelectedChildren(Array.from(childPermissions));
                setActions(actionPermissions);


            }
        } catch (error) {
        }
    };

    useEffect(() => {
        getAllSublist()
        getAllrolesList()

    }, [])


    const handleParentSelect = (parentId, subMenus) => {
        let updatedSelectedChildren = [...selectedChildren];
        let updatedActions = { ...actions };

        if (selectedParent.includes(parentId)) {
            // If parent is already selected, remove it and all its children
            updatedSelectedChildren = updatedSelectedChildren.filter(
                (id) => !subMenus.map((sub) => sub.menu_id).includes(id)
            );
            setSelectedParent(selectedParent.filter((id) => id !== parentId));
        } else {
            // If parent is selected, add all its children
            updatedSelectedChildren = [
                ...new Set([...updatedSelectedChildren, ...subMenus.map((sub) => sub.menu_id)]),
            ];
            setSelectedParent([...selectedParent, parentId]);
        }

        setSelectedChildren(updatedSelectedChildren);
        setActions(updatedActions);
    };
    // Handle Child Selection
    const handleChildSelect = (childId, parentId) => {
        let updatedSelectedChildren = [...selectedChildren];

        if (selectedChildren.includes(childId)) {
            // If child is selected, remove it
            updatedSelectedChildren = updatedSelectedChildren.filter((id) => id !== childId);
        } else {
            // If child is selected, add it and ensure parent is also selected
            updatedSelectedChildren.push(childId);
            if (!selectedParent.includes(parentId)) {
                setSelectedParent([...selectedParent, parentId]);
            }
        }

        // If no more children are selected, remove the parent
        const parentHasChildren = modulepermissions.find(
            (mod) => mod.menu_id === parentId
        )?.sub_menus?.some((sub) => updatedSelectedChildren.includes(sub.menu_id));

        if (!parentHasChildren) {
            setSelectedParent(selectedParent.filter((id) => id !== parentId));
        }

        setSelectedChildren(updatedSelectedChildren);
    };
    const handleActionSelect = (menuId, actionType) => {
        setActions((prev) => ({
            ...prev,
            [menuId]: {
                ...prev[menuId],
                [actionType]: prev[menuId]?.[actionType] === "10" ? "" : "10",
            },
        }));
    };


    const onSubmit = async (data) => {


        const req = {
            role_name: data.roleName,
            createdatesrole: data.createdatesrole,
            parent_id: selectedParent.join(",") || "",
            child_id: selectedChildren.join(",") || "",
            add: selectedChildren
                .filter((id) => actions[id]?.add === "10")
                .join(",") || "",

            edit: selectedChildren
                .filter((id) => actions[id]?.edit === "10")
                .join(",") || "",

            delete: selectedChildren
                .filter((id) => actions[id]?.delete === "10")
                .join(",") || "",

            view: selectedChildren
                .filter((id) => actions[id]?.view === "10")
                .join(",") || "",
        };

        if (!isEdited) {
            try {
                var rolepost = await axios.post(`/api/v1/roles/`, req,);
                if (rolepost.data) {
                    setIsFormVisible(false)
                    setaddrolespopup(false)
                    getAllrolesList();
                }
                setLoading(false);
                setDisable(false)
            } catch (error) {
                setLoading(false);
                setDisable(false)
            }
        } else {
            try {
                var response = await axios.put(`/api/v1/roles/${editId}/`, req,);
                if (response.data) {
                    setaddrolespopup(false)
                    getAllrolesList();
                }
                setLoading(false);
                setDisable(false)
            } catch (error) {
                setLoading(false);
                setDisable(false)
            }
        }
    };

    const deleteHandler = async () => {
        let id = deleteRowId
        await axios.delete(`/api/v1/roles/${id}/`)
            .then((resp) => {
                getAllrolesList()
                setSmShow(false)
                setSuccessAlert(true)
            })
            .catch((error) => {
            });
    }
    const [addrolespopup, setaddrolespopup] = useState(false)

    return (
        <React.Fragment>
            <Container fluid={true}>
                <div className="admin-dash">
                    <div className="container-fluid">
                        <div className="row lookup-cust">
                            <div className="col-6">
                                <Accordion
                                    activeIndex={null} // This ensures the accordion is initially closed
                                    multiple={false}
                                    style={{ width: "100%" }}
                                    onTabOpen={fetchResumeSource}>
                                    <AccordionTab header="Resume Source" >
                                        <div>
                                            {/* Data Table with pagination */}
                                            <DataTable
                                                value={jobTitlesData}
                                                responsiveLayout="scroll"
                                                paginator
                                                rows={5} // Number of rows per page
                                                // rowsPerPageOptions={[5, 10, 15]} // Options for the number of rows per page
                                                style={{ marginTop: "1rem" }}
                                            >
                                                <Column
                                                    field="value"
                                                    header="Value"
                                                    style={{ width: "25%" }}
                                                />
                                                <Column
                                                    field="description"
                                                    header="Description"
                                                    style={{ width: "25%" }}
                                                />
                                                <Column
                                                    field="type"
                                                    header="Type"
                                                    style={{ width: "25%" }}
                                                />

                                                {/* Actions column */}
                                                <Column
                                                    header="Actions"
                                                    body={rowData => (
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                            }}
                                                        >
                                                            {editJobTitleIcon(rowData)}
                                                            {deleteJobTitleIcon(rowData)}
                                                        </div>
                                                    )}
                                                    style={{ width: "10%" }}
                                                />
                                            </DataTable>

                                            <div className="d-flex justify-content-end">
                                                {/* Add new job title button */}
                                                <Button
                                                    label="Add More"
                                                    icon="pi pi-briefcase"
                                                    onClick={addNewJobTitle}
                                                    className="mt-3"
                                                    style={{ borderRadius: "4px" }}
                                                />
                                            </div>

                                            {/* Dialog for adding/editing job title */}
                                            <Dialog
                                                header={
                                                    isEditing
                                                        ? "Edit Resume Source"
                                                        : "Add New Resume Source"
                                                }
                                                visible={isEditDialogVisible}
                                                style={{ width: "30vw" }}
                                                onHide={handleCancelJobTitle}
                                            >
                                                <div>
                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="jobTitleValue" className="block">
                                                                Value
                                                            </label>
                                                            <InputText
                                                                id="jobTitleValue"
                                                                value={currentJobTitle.value}
                                                                onChange={e =>
                                                                    setCurrentJobTitle(prev => ({
                                                                        ...prev,
                                                                        value: e.target.value,
                                                                    }))
                                                                }
                                                                className="w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label
                                                                htmlFor="jobTitleDescription"
                                                                className="block"
                                                            >
                                                                Description
                                                            </label>
                                                            <InputText
                                                                id="jobTitleDescription"
                                                                value={currentJobTitle.description}
                                                                onChange={e => {
                                                                    e.stopPropagation();
                                                                    setCurrentJobTitle(prev => ({
                                                                        ...prev,
                                                                        description: e.target.value,
                                                                    }))
                                                                }}
                                                                className="w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="jobTitleType" className="block">
                                                                Type
                                                            </label>
                                                            <Dropdown
                                                                id="jobTitleType"
                                                                value={currentJobTitle.type}
                                                                options={typeOptions}
                                                                onChange={e =>
                                                                    setCurrentJobTitle(prev => ({
                                                                        ...prev,
                                                                        type: e.value,
                                                                    }))
                                                                }
                                                                placeholder="Select Type"
                                                                className="bgclr w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col xl={12}>
                                                            <div className="d-flex justify-content-end mt-2">
                                                                <Button
                                                                    color="primary btn-main me-2"
                                                                    onClick={handleSaveJobTitle}
                                                                >
                                                                    <i className="pi pi-check me-1"></i> Ok
                                                                </Button>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Dialog>
                                        </div>
                                    </AccordionTab>
                                </Accordion>

                                <Accordion
                                    className="mt-3"
                                    multiple={false}
                                    style={{ width: "100%" }}
                                    onTabOpen={fetchAddressCity}
                                >
                                    <AccordionTab header="Address City">
                                        <div>
                                            {/* Data Table */}
                                            <DataTable
                                                value={citiesData}
                                                responsiveLayout="scroll"
                                                paginator
                                                rows={5}
                                            >
                                                <Column field="state_name" header="State Name" style={{ width: "25%" }} />

                                                <Column field="name" header="Name" style={{ width: "25%" }} />


                                                {/* Actions column */}
                                                <Column
                                                    header="Actions"
                                                    body={rowData => (
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                gap: "5px",
                                                                alignItems: "center",
                                                            }}
                                                        >
                                                            {editCityIcon(rowData)}
                                                            {deleteCityIcon(rowData)}
                                                        </div>
                                                    )}
                                                    style={{ width: "15%", textAlign: "center" }}
                                                />

                                            </DataTable>

                                            <div className="d-flex justify-content-end">
                                                {/* Add new state button */}
                                                <Button
                                                    label="Add More"
                                                    icon="pi pi-plus"
                                                    onClick={addNewCity}
                                                    className="mt-3"
                                                />
                                            </div>


                                            {/* Dialog for adding/editing state */}
                                            <Dialog
                                                header={isCityEditing ? "Edit City" : "Add City"}
                                                visible={isCityEditDialogVisible}
                                                style={{ width: "30vw" }}
                                                onHide={handleCancelCity}
                                            >
                                                <div>
                                                    {/* Country Dropdown */}
                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="country" className="block">Country</label>
                                                            <Dropdown
                                                                id="country"
                                                                value={selectedCountry}
                                                                options={addCountries}
                                                                optionLabel="name"
                                                                optionValue="id"
                                                                onChange={(e) => {
                                                                    setSelectedCountry(e.value);
                                                                    setSelectedCity(null);
                                                                    getaddStates(e.value);
                                                                }}
                                                                placeholder={loadingCountries ? "Loading..." : "Select Country"}
                                                                className="w-full"
                                                                disabled={loadingCountries}
                                                            />

                                                        </Col>
                                                    </Row>

                                                    {/* State Dropdown */}
                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="State" className="block">State</label>
                                                            <Dropdown
                                                                id="State"
                                                                value={selectedCity}
                                                                options={addStates}
                                                                optionLabel="name"
                                                                optionValue="id"
                                                                onChange={(e) => setSelectedCity(e.value)}
                                                                placeholder="Select State"
                                                                className="w-full"
                                                                disabled={!selectedCountry}
                                                            />


                                                        </Col>
                                                    </Row>

                                                    {/* City Input */}
                                                    {/* <Row className="mb-2">
                                <Col xl={12}>
                                  <label htmlFor="City" className="block">City</label>
                                  <InputText
                                    id="City"
                                    value={currentCity.name}
                                    onChange={e =>
                                      setCurrentCity(prev => ({
                                        ...prev,
                                        name: e.target.value,
                                      }))
                                    }
                                    className="w-full"
                                    disabled={!selectedCity} // Disable until state is selected
                                  />

                                </Col>
                              </Row> */}

                                                    {/* Save & Cancel Buttons */}
                                                    <Row>
                                                        <Col xl={12}>
                                                            <div className="d-flex justify-content-end mt-2">
                                                                <Button color="primary btn-main me-2" onClick={handleSaveCity}>
                                                                    <i className="pi pi-check me-1"></i> Ok
                                                                </Button>
                                                                <Button color="btn btn-primary cancel-outlinebtn" onClick={handleCancelCity}>
                                                                    <i className="pi pi-times me-1"></i> Cancel
                                                                </Button>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Dialog>

                                        </div>
                                    </AccordionTab>
                                </Accordion>

                                <Accordion
                                    className="mt-3"
                                    multiple={false}
                                    style={{ width: "100%" }}
                                    onTabOpen={fetchAddressState}
                                >
                                    <AccordionTab header="Address State">
                                        <div>
                                            {/* Data Table */}
                                            <DataTable
                                                value={statesData}
                                                responsiveLayout="scroll"
                                                paginator
                                                rows={5}
                                            >
                                                <Column field="country_name" header="Country Name" style={{ width: "25%" }} />

                                                <Column field="name" header="Name" style={{ width: "25%" }} />


                                                {/* Actions column */}
                                                <Column
                                                    header="Actions"
                                                    body={rowData => (
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                gap: "5px",
                                                                alignItems: "center",
                                                            }}
                                                        >
                                                            {editStateIcon(rowData)}
                                                            {deleteStateIcon(rowData)}
                                                        </div>
                                                    )}
                                                    style={{ width: "15%", textAlign: "center" }} // Reduce column width for better spacing
                                                />

                                            </DataTable>

                                            <div className="d-flex justify-content-end">
                                                {/* Add new state button */}
                                                <Button
                                                    label="Add More"
                                                    icon="pi pi-plus"
                                                    onClick={addNewState}
                                                    className="mt-3"
                                                />
                                            </div>

                                            {/* Dialog for adding/editing state */}
                                            <Dialog
                                                header={isStateEditing ? "Edit State" : "Add State"}
                                                visible={isStateEditDialogVisible}
                                                style={{ width: "30vw" }}
                                                onHide={handleCancelState}
                                            >
                                                <div>
                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="country" className="block">Country</label>
                                                            <Dropdown
                                                                id="country"
                                                                value={selectedCountry}
                                                                options={addCountries}
                                                                optionLabel="name"
                                                                optionValue="id"
                                                                onChange={(e) => {
                                                                    setSelectedCountry(e.value);
                                                                    setSelectedCity(null);
                                                                    getaddStates(e.value);
                                                                }}
                                                                placeholder={loadingCountries ? "Loading..." : "Select Country"}
                                                                className="w-full"
                                                                disabled={loadingCountries}
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="stateName" className="block">
                                                                Name
                                                            </label>
                                                            <InputText
                                                                id="stateName"
                                                                value={currentEditingState.name}
                                                                onChange={e =>
                                                                    setCurrentEditingState(prev => ({
                                                                        ...prev,
                                                                        name: e.target.value,
                                                                    }))
                                                                }
                                                                className="w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col xl={12}>
                                                            <div className="d-flex justify-content-end mt-2">
                                                                <Button
                                                                    color="primary btn-main me-2"
                                                                    onClick={handleSaveState}
                                                                >
                                                                    <i className="pi pi-check me-1"></i> Ok
                                                                </Button>
                                                                <Button
                                                                    color="btn btn-primary cancel-outlinebtn"
                                                                    onClick={handleCancelState}
                                                                >
                                                                    <i className="pi pi-times me-1"></i> Cancel
                                                                </Button>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Dialog>

                                        </div>
                                    </AccordionTab>
                                </Accordion>

                                <Accordion className="mt-3" multiple={false} style={{ width: "100%" }} onTabOpen={fetchAddressCountry}>
                                    <AccordionTab header="Address Country">
                                        <div>
                                            <DataTable value={countriesData} responsiveLayout="scroll" paginator rows={5}>
                                                <Column field="name" header="Name" style={{ width: "25%" }} />

                                                {/* Actions column */}
                                                <Column
                                                    header="Actions"
                                                    body={(rowData) => (
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                gap: "8px", // Controls spacing between icons
                                                                alignItems: "center", // Aligns icons properly
                                                                justifyContent: "center", // Centers them inside the column
                                                            }}
                                                        >
                                                            {editCountryIcon(rowData)}
                                                            {deleteCountryIcon(rowData)}
                                                        </div>
                                                    )}
                                                    style={{ width: "15%", textAlign: "center" }} // Adjust width to fix spacing
                                                />
                                            </DataTable>

                                            <div className="d-flex justify-content-end">
                                                <Button
                                                    label="Add More"
                                                    icon="pi pi-plus"
                                                    onClick={addNewCountry}
                                                    className="mt-3"
                                                />
                                            </div>

                                            {/* Dialog for adding/editing country */}
                                            <Dialog
                                                header={isCountryBeingEdited ? "Edit Country" : "Add Country"}
                                                visible={isCountryDialogVisible}
                                                style={{ width: "30vw" }}
                                                onHide={handleCancelCountry}
                                            >
                                                <div>
                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="countryName" className="block">Name</label>
                                                            <InputText
                                                                id="countryName"
                                                                value={currentCountry.name}
                                                                onChange={(e) =>
                                                                    setCurrentCountry((prev) => ({
                                                                        ...prev,
                                                                        name: e.target.value,
                                                                    }))
                                                                }
                                                                className="w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col xl={12}>
                                                            <div className="d-flex justify-content-end mt-2">
                                                                <Button color="primary btn-main me-2" onClick={handleSaveCountry}>
                                                                    <i className="pi pi-check me-1"></i> Ok
                                                                </Button>
                                                                <Button color="btn btn-primary cancel-outlinebtn" onClick={handleCancelCountry}>
                                                                    <i className="pi pi-times me-1"></i> Cancel
                                                                </Button>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Dialog>
                                        </div>
                                    </AccordionTab>
                                </Accordion>

                                <Accordion
                                    className="mt-3"
                                    multiple={false}
                                    style={{ width: "100%" }}
                                >
                                    <AccordionTab header="Address Label">
                                        <div>
                                            {/* Add new address label button */}

                                            {/* Data Table with Pagination */}
                                            <DataTable
                                                value={addressLabelsData}
                                                responsiveLayout="scroll"
                                                paginator
                                                rows={5}
                                            >
                                                <Column
                                                    field="label"
                                                    header="Value"
                                                    style={{ width: "25%" }}
                                                />
                                                <Column
                                                    field="output"
                                                    header="Description"
                                                    style={{ width: "25%" }}
                                                />
                                                <Column
                                                    field="type"
                                                    header="Type"
                                                    style={{ width: "25%" }}
                                                />

                                                {/* Actions column */}
                                                <Column
                                                    header="Actions"
                                                    body={rowData => (
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                            }}
                                                        >
                                                            {editAddressLabelIcon(rowData)}
                                                            {deleteAddressLabelIcon(rowData)}
                                                        </div>
                                                    )}
                                                    style={{ width: "10%" }}
                                                />
                                            </DataTable>

                                            <div className="d-flex justify-content-end">
                                                <Button
                                                    label="Add more"
                                                    icon="pi pi-plus"
                                                    onClick={addNewAddressLabel}
                                                    className="mt-3"
                                                />
                                            </div>

                                            {/* Dialog for adding/editing address label */}
                                            <Dialog
                                                header={
                                                    isEditingAddressLabel
                                                        ? "Edit Address Label"
                                                        : "Add Address Label"
                                                }
                                                visible={isAddressLabelEditDialogVisible}
                                                style={{ width: "30vw" }}
                                                onHide={handleCancelAddressLabel}
                                            >
                                                <div>
                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="addressLabel" className="block">
                                                                Value
                                                            </label>
                                                            <InputText
                                                                id="addressLabel"
                                                                value={currentAddressLabel.label}
                                                                onChange={e =>
                                                                    setCurrentAddressLabel(prev => ({
                                                                        ...prev,
                                                                        label: e.target.value,
                                                                    }))
                                                                }
                                                                className="w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="addressOutput" className="block">
                                                                Description
                                                            </label>
                                                            <InputText
                                                                id="addressOutput"
                                                                value={currentAddressLabel.output}
                                                                onChange={e =>
                                                                    setCurrentAddressLabel(prev => ({
                                                                        ...prev,
                                                                        output: e.target.value,
                                                                    }))
                                                                }
                                                                className="w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="addressType" className="block">
                                                                Type
                                                            </label>
                                                            <Dropdown
                                                                id="addressType"
                                                                value={currentAddressLabel.type}
                                                                options={addressLabelTypeOptions}
                                                                onChange={e =>
                                                                    setCurrentAddressLabel(prev => ({
                                                                        ...prev,
                                                                        type: e.value,
                                                                    }))
                                                                }
                                                                placeholder="Select Type"
                                                                className="w-full bgclr"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col xl={12}>
                                                            <div className="d-flex justify-content-end mt-2">
                                                                <Button
                                                                    color="primary btn-main me-2"
                                                                    onClick={handleSaveAddressLabel}
                                                                >
                                                                    <i className="pi pi-check me-1"></i> Ok
                                                                </Button>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Dialog>
                                        </div>
                                    </AccordionTab>
                                </Accordion>

                                <Accordion
                                    className="mt-3"
                                    multiple={false}
                                    style={{ width: "100%" }}
                                    onTabOpen={() => fetchSkills()}
                                >
                                    <AccordionTab header="Skills" >
                                        <div>
                                            {/* Add new skill button */}

                                            {/* Data Table with Pagination */}
                                            <DataTable
                                                value={skillsData}
                                                responsiveLayout="scroll"
                                                paginator
                                                rows={5}
                                            >
                                                <Column
                                                    field="name"
                                                    header="Value"
                                                    style={{ width: "30%" }}
                                                />
                                                <Column
                                                    field="description"
                                                    header="Description"
                                                    style={{ width: "30%" }}
                                                />
                                                <Column
                                                    field="type"
                                                    header="Type"
                                                    style={{ width: "20%" }}
                                                />

                                                {/* Actions column */}
                                                <Column
                                                    header="Actions"
                                                    body={rowData => (
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                            }}
                                                        >
                                                            {editSkillIcon(rowData)}
                                                            {deleteSkillIcon(rowData)}
                                                        </div>
                                                    )}
                                                    style={{ width: "20%" }}
                                                />
                                            </DataTable>

                                            <div className="d-flex justify-content-end">
                                                <Button
                                                    label="Add Skill"
                                                    icon="pi pi-plus"
                                                    onClick={addNewSkill}
                                                    className="mt-3"
                                                />
                                            </div>

                                            {/* Dialog for adding/editing skill */}
                                            <Dialog
                                                header={isEditingSkill ? "Edit Skill" : "Add New Skill"}
                                                visible={isSkillEditDialogVisible}
                                                style={{ width: "30vw" }}
                                                onHide={handleCancelSkill}
                                            >
                                                <div>
                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="skillName" className="block">
                                                                value
                                                            </label>
                                                            <InputText
                                                                id="skillName"
                                                                value={currentSkill.name}
                                                                onChange={e =>
                                                                    setCurrentSkill(prev => ({
                                                                        ...prev,
                                                                        name: e.target.value,
                                                                    }))
                                                                }
                                                                className="w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label
                                                                htmlFor="skillDescription"
                                                                className="block"
                                                            >
                                                                Description
                                                            </label>
                                                            <InputText
                                                                id="skillDescription"
                                                                value={currentSkill.description}
                                                                onChange={e =>
                                                                    setCurrentSkill(prev => ({
                                                                        ...prev,
                                                                        description: e.target.value,
                                                                    }))
                                                                }
                                                                className="w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="skillType" className="block">
                                                                Type
                                                            </label>
                                                            <Dropdown
                                                                id="skillType"
                                                                value={currentSkill.type}
                                                                options={skillTypeOptions}
                                                                onChange={e =>
                                                                    setCurrentSkill(prev => ({
                                                                        ...prev,
                                                                        type: e.value,
                                                                    }))
                                                                }
                                                                placeholder="Select Type"
                                                                className="bgclr w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col xl={12}>
                                                            <div className="d-flex justify-content-end mt-2">
                                                                <Button
                                                                    color="primary btn-main me-2"
                                                                    onClick={handleSaveSkill}
                                                                >
                                                                    <i className="pi pi-check me-1"></i> Ok
                                                                </Button>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Dialog>
                                        </div>
                                    </AccordionTab>
                                </Accordion>

                                <Accordion
                                    className="mt-3"
                                    multiple={false}
                                    style={{ width: "100%" }}
                                    onTabOpen={fetchEmployeeType}
                                >
                                    <AccordionTab header="Employee type">
                                        <div>
                                            {/* Add new employee button */}

                                            {/* Data Table with Pagination */}
                                            <DataTable
                                                value={employeesData}
                                                responsiveLayout="scroll"
                                                paginator
                                                rows={5}
                                            >
                                                <Column
                                                    field="name"
                                                    header="Value"
                                                    style={{ width: "25%" }}
                                                />
                                                <Column
                                                    field="description"
                                                    header="Description"
                                                    style={{ width: "25%" }}
                                                />
                                                <Column
                                                    field="type"
                                                    header="Type"
                                                    style={{ width: "25%" }}
                                                />

                                                {/* Actions column */}
                                                <Column
                                                    header="Actions"
                                                    body={rowData => (
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                            }}
                                                        >
                                                            {editEmployeeIcon(rowData)}
                                                            {deleteEmployeeIcon(rowData)}
                                                        </div>
                                                    )}
                                                    style={{ width: "25%" }}
                                                />
                                            </DataTable>

                                            <div className="d-flex justify-content-end">
                                                <Button
                                                    label="Add More"
                                                    icon="pi pi-plus"
                                                    onClick={addNewEmployee}
                                                    className="mt-3"
                                                />
                                            </div>

                                            {/* Dialog for adding/editing employee */}
                                            <Dialog
                                                header={
                                                    isEditingEmployee ? "Edit Employee" : "Add Employee"
                                                }
                                                visible={isEmployeeEditDialogVisible}
                                                style={{ width: "30vw" }}
                                                onHide={handleCancelEmployee}
                                            >
                                                <div>
                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="employeeName" className="block">
                                                                Value
                                                            </label>
                                                            <InputText
                                                                id="employeeName"
                                                                value={currentEmployee.name}
                                                                onChange={e =>
                                                                    setCurrentEmployee(prev => ({
                                                                        ...prev,
                                                                        name: e.target.value,
                                                                    }))
                                                                }
                                                                className="w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label
                                                                htmlFor="employeeDescription"
                                                                className="block"
                                                            >
                                                                Description
                                                            </label>
                                                            <InputText
                                                                id="employeeDescription"
                                                                value={currentEmployee.description}
                                                                onChange={e =>
                                                                    setCurrentEmployee(prev => ({
                                                                        ...prev,
                                                                        description: e.target.value,
                                                                    }))
                                                                }
                                                                className="bgclr w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="employeeType" className="block">
                                                                Type
                                                            </label>
                                                            <Dropdown
                                                                id="employeeType"
                                                                value={currentEmployee.type}
                                                                options={employeeTypeOptions}
                                                                onChange={e =>
                                                                    setCurrentEmployee(prev => ({
                                                                        ...prev,
                                                                        type: e.value,
                                                                    }))
                                                                }
                                                                placeholder="Select Type"
                                                                className="bgclr w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col xl={12}>
                                                            <div className="d-flex justify-content-end mt-2">
                                                                <Button
                                                                    color="primary btn-main me-2"
                                                                    onClick={handleSaveEmployee}
                                                                >
                                                                    <i className="pi pi-check me-1"></i> Ok
                                                                </Button>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Dialog>
                                        </div>
                                    </AccordionTab>
                                </Accordion>

                                <Accordion
                                    className="mt-3"
                                    multiple={false}
                                    style={{ width: "100%" }}
                                >
                                    <AccordionTab header="Source">
                                        <div>
                                            {/* Data Table with Pagination */}
                                            <DataTable
                                                value={sourcesData}
                                                responsiveLayout="scroll"
                                                paginator
                                                rows={5}
                                            >
                                                <Column
                                                    field="name"
                                                    header="Value"
                                                    style={{ width: "25%" }}
                                                />
                                                <Column
                                                    field="description"
                                                    header="Description"
                                                    style={{ width: "25%" }}
                                                />
                                                <Column
                                                    field="type"
                                                    header="Type"
                                                    style={{ width: "25%" }}
                                                />

                                                {/* Actions column */}
                                                <Column
                                                    header="Actions"
                                                    body={rowData => (
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                            }}
                                                        >
                                                            {editSourceIcon(rowData)}
                                                            {deleteSourceIcon(rowData)}
                                                        </div>
                                                    )}
                                                    style={{ width: "10%" }}
                                                />
                                            </DataTable>

                                            <div className="d-flex justify-content-end">
                                                {/* Add new source button */}
                                                <Button
                                                    label="Add More"
                                                    icon="pi pi-plus"
                                                    onClick={addNewSource}
                                                    className="mt-3"
                                                />
                                            </div>

                                            {/* Dialog for adding/editing source */}
                                            <Dialog
                                                header={
                                                    isEditingSource ? "Edit Source" : "Add New Source"
                                                }
                                                visible={isSourceEditDialogVisible}
                                                style={{ width: "30vw" }}
                                                onHide={handleCancelSource}
                                            >
                                                <div>
                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="sourceName" className="block">
                                                                Value
                                                            </label>
                                                            <InputText
                                                                id="sourceName"
                                                                value={currentSource.name}
                                                                onChange={e =>
                                                                    setCurrentSource(prev => ({
                                                                        ...prev,
                                                                        name: e.target.value,
                                                                    }))
                                                                }
                                                                className="w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label
                                                                htmlFor="sourceDescription"
                                                                className="block"
                                                            >
                                                                Description
                                                            </label>
                                                            <InputText
                                                                id="sourceDescription"
                                                                value={currentSource.description}
                                                                onChange={e =>
                                                                    setCurrentSource(prev => ({
                                                                        ...prev,
                                                                        description: e.target.value,
                                                                    }))
                                                                }
                                                                className="w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="sourceType" className="block">
                                                                Type
                                                            </label>
                                                            <Dropdown
                                                                id="sourceType"
                                                                value={currentSource.type}
                                                                options={sourceTypeOptions}
                                                                onChange={e =>
                                                                    setCurrentSource(prev => ({
                                                                        ...prev,
                                                                        type: e.value,
                                                                    }))
                                                                }
                                                                placeholder="Select Type"
                                                                className="bgclr w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col xl={12}>
                                                            <div className="d-flex justify-content-end mt-2">
                                                                <Button
                                                                    color="primary btn-main me-2"
                                                                    onClick={handleSaveSource}
                                                                >
                                                                    <i className="pi pi-check me-1"></i> Ok
                                                                </Button>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Dialog>
                                        </div>
                                    </AccordionTab>
                                </Accordion>

                                <Accordion
                                    className="mt-3"
                                    multiple={false}
                                    style={{ width: "100%" }}
                                >
                                    <AccordionTab header="Reffered by">
                                        <div>
                                            {/* Data Table with Pagination */}
                                            <DataTable
                                                value={referredData}
                                                responsiveLayout="scroll"
                                                paginator
                                                rows={5}
                                            >
                                                <Column
                                                    field="value"
                                                    header="Value"
                                                    style={{ width: "30%" }}
                                                />
                                                <Column
                                                    field="description"
                                                    header="Description"
                                                    style={{ width: "30%" }}
                                                />
                                                <Column
                                                    field="type"
                                                    header="Type"
                                                    style={{ width: "20%" }}
                                                />

                                                {/* Actions column */}
                                                <Column
                                                    header="Actions"
                                                    body={rowData => (
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                            }}
                                                        >
                                                            {editReferredIcon(rowData)}
                                                            {deleteReferredIcon(rowData)}
                                                        </div>
                                                    )}
                                                    style={{ width: "20%" }}
                                                />
                                            </DataTable>

                                            <div className="d-flex justify-content-end">
                                                {/* Add new referred button */}
                                                <Button
                                                    label="Add Referred"
                                                    icon="pi pi-plus"
                                                    onClick={addNewReferred}
                                                    className="mt-3"
                                                />
                                            </div>

                                            {/* Dialog for adding/editing referred */}
                                            <Dialog
                                                header={
                                                    isEditingReferred
                                                        ? "Edit Referred"
                                                        : "Add New Referred"
                                                }
                                                visible={isReferredEditDialogVisible}
                                                style={{ width: "30vw" }}
                                                onHide={handleCancelReferred}
                                            >
                                                <div>
                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="value" className="block">
                                                                Value
                                                            </label>
                                                            <InputText
                                                                id="value"
                                                                value={currentReferred.value}
                                                                onChange={e =>
                                                                    setCurrentReferred(prev => ({
                                                                        ...prev,
                                                                        value: e.target.value,
                                                                    }))
                                                                }
                                                                className="w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="description" className="block">
                                                                Description
                                                            </label>
                                                            <InputText
                                                                id="description"
                                                                value={currentReferred.description}
                                                                onChange={e =>
                                                                    setCurrentReferred(prev => ({
                                                                        ...prev,
                                                                        description: e.target.value,
                                                                    }))
                                                                }
                                                                className="w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="type" className="block">
                                                                Type
                                                            </label>
                                                            <Dropdown
                                                                id="type"
                                                                value={currentReferred.type}
                                                                options={referredTypeOptions}
                                                                onChange={e =>
                                                                    setCurrentReferred(prev => ({
                                                                        ...prev,
                                                                        type: e.value,
                                                                    }))
                                                                }
                                                                placeholder="Select Type"
                                                                className="bgclr w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col xl={12}>
                                                            <div className="d-flex justify-content-end mt-2">
                                                                <Button
                                                                    color="primary btn-main me-2"
                                                                    onClick={handleSaveReferred}
                                                                >
                                                                    <i className="pi pi-check me-1"></i> Ok
                                                                </Button>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Dialog>
                                        </div>
                                    </AccordionTab>
                                </Accordion>

                                <Accordion
                                    className="mt-3"
                                    multiple={false}
                                    style={{ width: "100%" }}
                                >
                                    <AccordionTab header="Document Type">
                                        <div>
                                            {/* Data Table with Pagination */}
                                            <DataTable
                                                value={docTypeData}
                                                responsiveLayout="scroll"
                                                paginator
                                                rows={5}
                                            >
                                                <Column
                                                    field="value"
                                                    header="Value"
                                                    style={{ width: "30%" }}
                                                />
                                                <Column
                                                    field="description"
                                                    header="Description"
                                                    style={{ width: "30%" }}
                                                />
                                                <Column
                                                    field="type"
                                                    header="Type"
                                                    style={{ width: "20%" }}
                                                />

                                                {/* Actions column */}
                                                <Column
                                                    header="Actions"
                                                    body={rowData => (
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                            }}
                                                        >
                                                            {editDocTypeIcon(rowData)}
                                                            {deleteDocTypeIcon(rowData)}
                                                        </div>
                                                    )}
                                                    style={{ width: "10%" }}
                                                />
                                            </DataTable>

                                            <div className="d-flex justify-content-end">
                                                {/* Add new Doc. Type button */}
                                                <Button
                                                    label="Add Document"
                                                    icon="pi pi-plus"
                                                    onClick={addNewDocType}
                                                    className="mt-3"
                                                />
                                            </div>

                                            {/* Dialog for adding/editing Doc. Type */}
                                            <Dialog
                                                header={
                                                    isEditingDocType
                                                        ? "Edit Doc. Type"
                                                        : "Add New Doc. Type"
                                                }
                                                visible={isDocTypeEditDialogVisible}
                                                style={{ width: "30vw" }}
                                                onHide={handleCancelDocType}
                                            >
                                                <div>
                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="value" className="block">
                                                                Value
                                                            </label>
                                                            <InputText
                                                                id="value"
                                                                value={currentDocType.value}
                                                                onChange={e =>
                                                                    setCurrentDocType(prev => ({
                                                                        ...prev,
                                                                        value: e.target.value,
                                                                    }))
                                                                }
                                                                className="w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="description" className="block">
                                                                Description
                                                            </label>
                                                            <InputText
                                                                id="description"
                                                                value={currentDocType.description}
                                                                onChange={e =>
                                                                    setCurrentDocType(prev => ({
                                                                        ...prev,
                                                                        description: e.target.value,
                                                                    }))
                                                                }
                                                                className="w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="type" className="block">
                                                                Type
                                                            </label>
                                                            <Dropdown
                                                                id="type"
                                                                value={currentDocType.type}
                                                                options={docTypeOptions}
                                                                onChange={e =>
                                                                    setCurrentDocType(prev => ({
                                                                        ...prev,
                                                                        type: e.value,
                                                                    }))
                                                                }
                                                                placeholder="Select Type"
                                                                className="bgclr w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col xl={12}>
                                                            <div className="d-flex justify-content-end mt-2">
                                                                <Button
                                                                    color="primary btn-main me-2"
                                                                    onClick={handleSaveDocType}
                                                                >
                                                                    <i className="pi pi-check me-1"></i> Ok
                                                                </Button>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Dialog>
                                        </div>
                                    </AccordionTab>
                                </Accordion>

                                <Accordion
                                    className="mt-3"
                                    multiple={false}
                                    style={{ width: "100%" }}
                                    onTabOpen={fetchDegree}
                                >
                                    <AccordionTab header="Degree" >
                                        <div>
                                            {/* Data Table with Pagination */}
                                            <DataTable
                                                value={degreeData}
                                                responsiveLayout="scroll"
                                                paginator
                                                rows={5}
                                            >
                                                <Column
                                                    field="value"
                                                    header="Value"
                                                    style={{ width: "30%" }}
                                                />
                                                <Column
                                                    field="description"
                                                    header="Description"
                                                    style={{ width: "30%" }}
                                                />
                                                <Column
                                                    field="type"
                                                    header="Type"
                                                    style={{ width: "20%" }}
                                                />

                                                {/* Actions column */}
                                                <Column
                                                    header="Actions"
                                                    body={rowData => (
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                            }}
                                                        >
                                                            {editDegreeIcon(rowData)}
                                                            {deleteDegreeIcon(rowData)}
                                                        </div>
                                                    )}
                                                    style={{ width: "20%" }}
                                                />
                                            </DataTable>
                                            <div className="d-flex justify-content-end">
                                                {/* Add new Degree button */}
                                                <Button
                                                    label="Add Degree"
                                                    icon="pi pi-plus"
                                                    onClick={addNewDegree}
                                                    className="mt-3"
                                                />
                                            </div>

                                            {/* Dialog for adding/editing Degree */}
                                            <Dialog
                                                header={
                                                    isEditingDegree ? "Edit Degree" : "Add New Degree"
                                                }
                                                visible={isDegreeEditDialogVisible}
                                                style={{ width: "30vw" }}
                                                onHide={handleCancelDegree}
                                            >
                                                <div>
                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="value" className="block">
                                                                Value
                                                            </label>
                                                            <InputText
                                                                id="value"
                                                                value={currentDegree.value}
                                                                onChange={e =>
                                                                    setCurrentDegree(prev => ({
                                                                        ...prev,
                                                                        value: e.target.value,
                                                                    }))
                                                                }
                                                                className="w-full "
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="description" className="block">
                                                                Description
                                                            </label>
                                                            <InputText
                                                                id="description"
                                                                value={currentDegree.description}
                                                                onChange={e =>
                                                                    setCurrentDegree(prev => ({
                                                                        ...prev,
                                                                        description: e.target.value,
                                                                    }))
                                                                }
                                                                className="w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="type" className="block">
                                                                Type
                                                            </label>
                                                            <Dropdown
                                                                id="type"
                                                                value={currentDegree.type}
                                                                options={degreeTypeOptions}
                                                                onChange={e =>
                                                                    setCurrentDegree(prev => ({
                                                                        ...prev,
                                                                        type: e.value,
                                                                    }))
                                                                }
                                                                placeholder="Select Type"
                                                                className="w-full bgclr"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col xl={12}>
                                                            <div className="d-flex justify-content-end mt-2">
                                                                <Button
                                                                    color="primary btn-main me-2"
                                                                    onClick={handleSaveDegree}
                                                                >
                                                                    <i className="pi pi-check me-1"></i> Ok
                                                                </Button>
                                                                <Button
                                                                    color="btn btn-primary cancel-outlinebtn"
                                                                    onClick={handleCancelDegree}
                                                                >
                                                                    <i className="pi pi-times me-1"></i> Cancel
                                                                </Button>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Dialog>
                                        </div>
                                    </AccordionTab>
                                </Accordion>

                                <Accordion
                                    className="mt-3"
                                    multiple={false}
                                    style={{ width: "100%" }}
                                >
                                    <AccordionTab header="School / Institute">
                                        <div>
                                            {/* Data Table with Pagination */}
                                            <DataTable
                                                value={institutionData}
                                                responsiveLayout="scroll"
                                                paginator
                                                rows={5}
                                            >
                                                <Column
                                                    field="value"
                                                    header="Value"
                                                    style={{ width: "30%" }}
                                                />
                                                <Column
                                                    field="description"
                                                    header="Description"
                                                    style={{ width: "30%" }}
                                                />
                                                <Column
                                                    field="type"
                                                    header="Type"
                                                    style={{ width: "20%" }}
                                                />

                                                {/* Actions column */}
                                                <Column
                                                    header="Actions"
                                                    body={rowData => (
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                            }}
                                                        >
                                                            {editInstitutionIcon(rowData)}
                                                            {deleteInstitutionIcon(rowData)}
                                                        </div>
                                                    )}
                                                    style={{ width: "20%" }}
                                                />
                                            </DataTable>

                                            <div className="d-flex justify-content-end">
                                                {/* Add new Institution button */}
                                                <Button
                                                    label="Add Institution"
                                                    icon="pi pi-plus"
                                                    onClick={addNewInstitution}
                                                    className="mt-3"
                                                />
                                            </div>

                                            {/* Dialog for adding/editing Institution */}
                                            <Dialog
                                                header={
                                                    isEditingInstitution
                                                        ? "Edit Institution"
                                                        : "Add New Institution"
                                                }
                                                visible={isInstitutionEditDialogVisible}
                                                style={{ width: "30vw" }}
                                                onHide={handleCancelInstitution}
                                            >
                                                <div>
                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="value" className="block">
                                                                Value
                                                            </label>
                                                            <InputText
                                                                id="value"
                                                                value={currentInstitution.value}
                                                                onChange={e =>
                                                                    setCurrentInstitution(prev => ({
                                                                        ...prev,
                                                                        value: e.target.value,
                                                                    }))
                                                                }
                                                                className="w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="description" className="block">
                                                                Description
                                                            </label>
                                                            <InputText
                                                                id="description"
                                                                value={currentInstitution.description}
                                                                onChange={e =>
                                                                    setCurrentInstitution(prev => ({
                                                                        ...prev,
                                                                        description: e.target.value,
                                                                    }))
                                                                }
                                                                className="w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="type" className="block">
                                                                Type
                                                            </label>
                                                            <Dropdown
                                                                id="type"
                                                                value={currentInstitution.type}
                                                                options={institutionTypeOptions}
                                                                onChange={e =>
                                                                    setCurrentInstitution(prev => ({
                                                                        ...prev,
                                                                        type: e.value,
                                                                    }))
                                                                }
                                                                placeholder="Select Type"
                                                                className="w-full bgclr"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col xl={12}>
                                                            <div className="d-flex justify-content-end mt-2">
                                                                <Button
                                                                    color="primary btn-main me-2"
                                                                    onClick={handleSaveInstitution}
                                                                >
                                                                    <i className="pi pi-check me-1"></i> Ok
                                                                </Button>
                                                                <Button
                                                                    color="btn btn-primary cancel-outlinebtn"
                                                                    onClick={handleCancelInstitution}
                                                                >
                                                                    <i className="pi pi-times me-1"></i> Cancel
                                                                </Button>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Dialog>
                                        </div>
                                    </AccordionTab>
                                </Accordion>




                            </div>

                            {/* Column 2 start  */}

                            <div className="col-6">


                                <Accordion
                                    multiple={false}
                                    style={{ width: "100%" }}
                                    onTabOpen={fetchJobStatus}
                                >
                                    <AccordionTab header="Job Status" >
                                        <div>
                                            {/* Data Table with Pagination */}
                                            <DataTable
                                                value={jobStatusData}
                                                responsiveLayout="scroll"
                                                paginator
                                                rows={5}
                                            >
                                                <Column
                                                    field="value"
                                                    header="Value"
                                                    style={{ width: "30%" }}
                                                />
                                                <Column
                                                    field="description"
                                                    header="Description"
                                                    style={{ width: "30%" }}
                                                />
                                                <Column
                                                    field="type"
                                                    header="Type"
                                                    style={{ width: "20%" }}
                                                />

                                                {/* Actions column */}
                                                <Column
                                                    header="Actions"
                                                    body={rowData => (
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                            }}
                                                        >
                                                            {editJobStatusIcon(rowData)}
                                                            {deleteJobStatusIcon(rowData)}
                                                        </div>
                                                    )}
                                                    style={{ width: "10%" }}
                                                />
                                            </DataTable>

                                            <div className="d-flex justify-content-end">
                                                {/* Add new Job Status button */}
                                                <Button
                                                    label="Add Job Status"
                                                    icon="pi pi-plus"
                                                    onClick={addNewJobStatus}
                                                    className="mt-3"
                                                />
                                            </div>

                                            {/* Dialog for adding/editing Job Status */}
                                            <Dialog
                                                header={
                                                    isEditingJobStatus
                                                        ? "Edit Job Status"
                                                        : "Add Job Status"
                                                }
                                                visible={isJobStatusDialogVisible}
                                                style={{ width: "30vw" }}
                                                onHide={handleCancelJobStatus}
                                            >
                                                <div>
                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="value" className="block">
                                                                Value
                                                            </label>
                                                            <InputText
                                                                id="value"
                                                                value={currentJobStatus.value}
                                                                onChange={e =>
                                                                    setCurrentJobStatus(prev => ({
                                                                        ...prev,
                                                                        value: e.target.value,
                                                                    }))
                                                                }
                                                                className="w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="description" className="block">
                                                                Description
                                                            </label>
                                                            <InputText
                                                                id="description"
                                                                value={currentJobStatus.description}
                                                                onChange={e =>
                                                                    setCurrentJobStatus(prev => ({
                                                                        ...prev,
                                                                        description: e.target.value,
                                                                    }))
                                                                }
                                                                className="w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="type" className="block">
                                                                Type
                                                            </label>
                                                            <Dropdown
                                                                id="type"
                                                                value={currentJobStatus.type}
                                                                options={jobStatusTypeOptions}
                                                                onChange={e =>
                                                                    setCurrentJobStatus(prev => ({
                                                                        ...prev,
                                                                        type: e.value,
                                                                    }))
                                                                }
                                                                placeholder="Select Type"
                                                                className="bgclr w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col xl={12}>
                                                            <div className="d-flex justify-content-end mt-2">
                                                                <Button
                                                                    color="primary btn-main me-2"
                                                                    onClick={handleSaveJobStatus}
                                                                >
                                                                    <i className="pi pi-check me-1"></i> Ok
                                                                </Button>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Dialog>
                                        </div>
                                    </AccordionTab>
                                </Accordion>


                                <Accordion
                                    className="mt-3"
                                    multiple={false}
                                    style={{ width: "100%" }}
                                    onTabOpen={fetchWorkPlace}
                                >
                                    <AccordionTab header="Workplace Type" >
                                        <div>
                                            <DataTable
                                                value={workTypeData}
                                                responsiveLayout="scroll"
                                                paginator
                                                rows={5}
                                            >
                                                <Column
                                                    field="value"
                                                    header="Value"
                                                    style={{ width: "30%" }}
                                                />
                                                <Column
                                                    field="description"
                                                    header="Description"
                                                    style={{ width: "30%" }}
                                                />
                                                <Column
                                                    field="type"
                                                    header="Type"
                                                    style={{ width: "20%" }}
                                                />
                                                <Column
                                                    header="Actions"
                                                    body={rowData => (
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                            }}
                                                        >
                                                            {editWorkTypeIcon(rowData)}
                                                            {deleteWorkTypeIcon(rowData)}
                                                        </div>
                                                    )}
                                                    style={{ width: "10%" }}
                                                />
                                            </DataTable>

                                            <div className="d-flex justify-content-end">
                                                <Button
                                                    label="Add Work Type"
                                                    icon="pi pi-plus"
                                                    onClick={addNewWorkType}
                                                    className="mt-3"
                                                />
                                            </div>

                                            <Dialog
                                                header={
                                                    isEditingWorkType ? "Edit Work Type" : "Add Work Type"
                                                }
                                                visible={isWorkTypeDialogVisible}
                                                style={{ width: "30vw" }}
                                                onHide={handleCancelWorkType}
                                            >
                                                <div>
                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="value" className="block">
                                                                Value
                                                            </label>
                                                            <InputText
                                                                id="value"
                                                                value={currentWorkType.value}
                                                                onChange={e =>
                                                                    setCurrentWorkType(prev => ({
                                                                        ...prev,
                                                                        value: e.target.value,
                                                                    }))
                                                                }
                                                                className="w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="description" className="block">
                                                                Description
                                                            </label>
                                                            <InputText
                                                                id="description"
                                                                value={currentWorkType.description}
                                                                onChange={e =>
                                                                    setCurrentWorkType(prev => ({
                                                                        ...prev,
                                                                        description: e.target.value,
                                                                    }))
                                                                }
                                                                className="w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="type" className="block">
                                                                Type
                                                            </label>
                                                            <Dropdown
                                                                id="type"
                                                                value={currentWorkType.type}
                                                                options={workTypeOptions}
                                                                onChange={e =>
                                                                    setCurrentWorkType(prev => ({
                                                                        ...prev,
                                                                        type: e.value,
                                                                    }))
                                                                }
                                                                placeholder="Select Type"
                                                                className="bgclr w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col xl={12}>
                                                            <div className="d-flex justify-content-end mt-2">
                                                                <Button
                                                                    color="primary btn-main me-2"
                                                                    onClick={handleSaveWorkType}
                                                                >
                                                                    <i className="pi pi-check me-1"></i> Ok
                                                                </Button>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Dialog>
                                        </div>
                                    </AccordionTab>
                                </Accordion>

                                <Accordion className="mt-3" multiple={false} style={{ width: "100%" }} onTabOpen={fetchJobFunction}>
                                    <AccordionTab header="Job Function">
                                        <div>
                                            <DataTable value={jobFunctionData} responsiveLayout="scroll" paginator rows={5}>
                                                <Column field="value" header="Value" style={{ width: "30%" }} />
                                                <Column field="description" header="Description" style={{ width: "30%" }} />
                                                <Column field="type" header="Type" style={{ width: "20%" }} />
                                                <Column
                                                    header="Actions"
                                                    body={rowData => (
                                                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                            {editJobFunction(rowData)}
                                                            {deleteJobFunctionIcon(rowData)}
                                                        </div>
                                                    )}
                                                    style={{ width: "10%" }}
                                                />
                                            </DataTable>

                                            <div className="d-flex justify-content-end">
                                                <Button label="Add Job Function" icon="pi pi-plus" onClick={addNewJobFunction} className="mt-3" />
                                            </div>

                                            {/* Dialog for Adding/Editing Job Function */}
                                            <Dialog
                                                header={isEditingJobFunction ? "Edit Job Function" : "Add Job Function"}
                                                visible={isJobFunctionDialogVisible}
                                                style={{ width: "30vw" }}
                                                onHide={handleCancelJobFunction}
                                            >
                                                <div>
                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="value">Value</label>
                                                            <InputText
                                                                id="value"
                                                                value={currentJobFunction.value}
                                                                onChange={e => setCurrentJobFunction({ ...currentJobFunction, value: e.target.value })}
                                                                className="w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="description">Description</label>
                                                            <InputText
                                                                id="description"
                                                                value={currentJobFunction.description}
                                                                onChange={e => setCurrentJobFunction({ ...currentJobFunction, description: e.target.value })}
                                                                className="w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="type" className="block">
                                                                Type
                                                            </label>
                                                            <Dropdown
                                                                id="type"
                                                                value={currentJobFunction.type}
                                                                options={jobFunctionOptions}
                                                                onChange={e =>
                                                                    setCurrentJobFunction(prev => ({
                                                                        ...prev,
                                                                        type: e.value,
                                                                    }))
                                                                }
                                                                placeholder="Select Type"
                                                                className="bgclr w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mt-2">
                                                        <Col xl={12} className="d-flex justify-content-end">
                                                            <Button className="btn-main" onClick={handleSaveJobFunction}>
                                                                <i className="pi pi-check me-1"></i> Save
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Dialog>
                                        </div>
                                    </AccordionTab>
                                </Accordion>

                                <Accordion
                                    className="mt-3"
                                    multiple={false}
                                    style={{ width: "100%" }}
                                    onTabOpen={fetchJobType}
                                >
                                    <AccordionTab header="Job Type" >
                                        <div>
                                            <DataTable
                                                value={jobTypeData}
                                                responsiveLayout="scroll"
                                                paginator
                                                rows={5}
                                            >
                                                <Column
                                                    field="value"
                                                    header="Value"
                                                    style={{ width: "30%" }}
                                                />
                                                <Column
                                                    field="description"
                                                    header="Description"
                                                    style={{ width: "30%" }}
                                                />
                                                <Column
                                                    field="type"
                                                    header="Type"
                                                    style={{ width: "20%" }}
                                                />
                                                <Column
                                                    header="Actions"
                                                    body={rowData => (
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                            }}
                                                        >
                                                            {editJobTypeIcon(rowData)}
                                                            {deleteJobTypeIcon(rowData)}
                                                        </div>
                                                    )}
                                                    style={{ width: "10%" }}
                                                />
                                            </DataTable>

                                            <div className="d-flex justify-content-end">
                                                <Button
                                                    label="Add Job Type"
                                                    icon="pi pi-plus"
                                                    onClick={addNewJobType}
                                                    className="mt-3"
                                                />
                                            </div>

                                            <Dialog
                                                header={
                                                    isEditingJobType ? "Edit Job Type" : "Add Job Type"
                                                }
                                                visible={isJobTypeDialogVisible}
                                                style={{ width: "30vw" }}
                                                onHide={handleCancelJobType}
                                            >
                                                <div>
                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="value" className="block">
                                                                Value
                                                            </label>
                                                            <InputText
                                                                id="value"
                                                                value={currentJobType.value}
                                                                onChange={e =>
                                                                    setCurrentJobType(prev => ({
                                                                        ...prev,
                                                                        value: e.target.value,
                                                                    }))
                                                                }
                                                                className="w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="description" className="block">
                                                                Description
                                                            </label>
                                                            <InputText
                                                                id="description"
                                                                value={currentJobType.description}
                                                                onChange={e =>
                                                                    setCurrentJobType(prev => ({
                                                                        ...prev,
                                                                        description: e.target.value,
                                                                    }))
                                                                }
                                                                className="w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="type" className="block">
                                                                Type
                                                            </label>
                                                            <Dropdown
                                                                id="type"
                                                                value={currentJobType.type}
                                                                options={jobTypeOptions}
                                                                onChange={e =>
                                                                    setCurrentJobType(prev => ({
                                                                        ...prev,
                                                                        type: e.value,
                                                                    }))
                                                                }
                                                                placeholder="Select Type"
                                                                className="bgclr w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col xl={12}>
                                                            <div className="d-flex justify-content-end mt-2">
                                                                <Button
                                                                    color="primary btn-main me-2"
                                                                    onClick={handleSaveJobType}
                                                                >
                                                                    <i className="pi pi-check me-1"></i> Ok
                                                                </Button>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Dialog>
                                        </div>
                                    </AccordionTab>
                                </Accordion>

                                <Accordion
                                    className="mt-3"
                                    multiple={false}
                                    style={{ width: "100%" }}
                                    onTabOpen={fetchDepartment}
                                >
                                    <AccordionTab header="Department" >
                                        <div>
                                            <DataTable
                                                value={departmentData}
                                                responsiveLayout="scroll"
                                                paginator
                                                rows={20}
                                            >
                                                <Column
                                                    field="value"
                                                    header="Value"
                                                    style={{ width: "30%" }}
                                                />
                                                <Column
                                                    field="description"
                                                    header="Description"
                                                    style={{ width: "30%" }}
                                                />
                                                <Column
                                                    field="company"
                                                    header="Company id"
                                                    style={{ width: "20%" }}
                                                />
                                                <Column
                                                    field="type"
                                                    header="Type"
                                                    style={{ width: "20%" }}
                                                />
                                                <Column
                                                    header="Actions"
                                                    body={rowData => (
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                            }}
                                                        >
                                                            {editDepartmentIcon(rowData)}
                                                            {deleteDepartmentIcon(rowData)}
                                                        </div>
                                                    )}
                                                    style={{ width: "10%" }}
                                                />
                                            </DataTable>

                                            <div className="d-flex justify-content-end">
                                                <Button
                                                    label="Add Department"
                                                    icon="pi pi-plus"
                                                    onClick={addNewDepartment}
                                                    className="mt-3"
                                                />
                                            </div>

                                            <Dialog
                                                header={
                                                    isEditingDepartment
                                                        ? "Edit Department"
                                                        : "Add Department"
                                                }
                                                visible={isDepartmentDialogVisible}
                                                style={{ width: "30vw" }}
                                                onHide={handleCancelDepartment}
                                            >
                                                <div>
                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="value" className="block">
                                                                Value
                                                            </label>
                                                            <InputText
                                                                id="value"
                                                                value={currentDepartment.value}
                                                                onChange={e =>
                                                                    setCurrentDepartment(prev => ({
                                                                        ...prev,
                                                                        value: e.target.value,
                                                                    }))
                                                                }
                                                                className="w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="description" className="block">
                                                                Description
                                                            </label>
                                                            <InputText
                                                                id="description"
                                                                value={currentDepartment.description}
                                                                onChange={e =>
                                                                    setCurrentDepartment(prev => ({
                                                                        ...prev,
                                                                        description: e.target.value,
                                                                    }))
                                                                }
                                                                className="w-full"
                                                            />
                                                        </Col>
                                                    </Row>
                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="company" className="block">
                                                                Company
                                                            </label>
                                                            <Dropdown
                                                                id="company"
                                                                value={currentDepartment.company}
                                                                options={allCompanies.map(company => ({ label: company.company_name, value: company.company_id }))}
                                                                onChange={e =>
                                                                    setCurrentDepartment(prev => ({
                                                                        ...prev,
                                                                        company: e.value,
                                                                    }))
                                                                }
                                                                placeholder="Select Company"
                                                                className="bgclr w-full"
                                                            />
                                                        </Col>
                                                    </Row>
                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="type" className="block">
                                                                Type
                                                            </label>
                                                            <Dropdown
                                                                id="type"
                                                                value={currentDepartment.type}
                                                                options={departmentTypeOptions}
                                                                onChange={e =>
                                                                    setCurrentDepartment(prev => ({
                                                                        ...prev,
                                                                        type: e.value,
                                                                    }))
                                                                }
                                                                placeholder="Select Type"
                                                                className="bgclr w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col xl={12}>
                                                            <div className="d-flex justify-content-end mt-2">
                                                                <Button
                                                                    color="primary btn-main me-2"
                                                                    onClick={handleSaveDepartment}
                                                                >
                                                                    <i className="pi pi-check me-1"></i> Ok
                                                                </Button>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Dialog>
                                        </div>
                                    </AccordionTab>
                                </Accordion>

                                <Accordion
                                    className="mt-3"
                                    multiple={false}
                                    style={{ width: "100%" }}
                                    onTabOpen={fetchSeniority}
                                >
                                    <AccordionTab header="Seniority" >
                                        <div>
                                            <DataTable
                                                value={seniorityData}
                                                responsiveLayout="scroll"
                                                paginator
                                                rows={5}
                                            >
                                                <Column
                                                    field="value"
                                                    header="Value"
                                                    style={{ width: "30%" }}
                                                />
                                                <Column
                                                    field="description"
                                                    header="Description"
                                                    style={{ width: "30%" }}
                                                />
                                                <Column
                                                    field="type"
                                                    header="Type"
                                                    style={{ width: "20%" }}
                                                />
                                                <Column
                                                    header="Actions"
                                                    body={rowData => (
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                            }}
                                                        >
                                                            {editSeniorityIcon(rowData)}
                                                            {deleteSeniorityIcon(rowData)}
                                                        </div>
                                                    )}
                                                    style={{ width: "10%" }}
                                                />
                                            </DataTable>

                                            <div className="d-flex justify-content-end">
                                                <Button
                                                    label="Add Seniority"
                                                    icon="pi pi-plus"
                                                    onClick={addNewSeniority}
                                                    className="mt-3"
                                                />
                                            </div>

                                            <Dialog
                                                header={
                                                    isEditingSeniority
                                                        ? "Edit Seniority"
                                                        : "Add Seniority"
                                                }
                                                visible={isSeniorityDialogVisible}
                                                style={{ width: "30vw" }}
                                                onHide={handleCancelSeniority}
                                            >
                                                <div>
                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="value" className="block">
                                                                Value
                                                            </label>
                                                            <InputText
                                                                id="value"
                                                                value={currentSeniority.value}
                                                                onChange={e =>
                                                                    setCurrentSeniority(prev => ({
                                                                        ...prev,
                                                                        value: e.target.value,
                                                                    }))
                                                                }
                                                                className="bgclr w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="description" className="block">
                                                                Description
                                                            </label>
                                                            <InputText
                                                                id="description"
                                                                value={currentSeniority.description}
                                                                onChange={e =>
                                                                    setCurrentSeniority(prev => ({
                                                                        ...prev,
                                                                        description: e.target.value,
                                                                    }))
                                                                }
                                                                className="w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="type" className="block">
                                                                Type
                                                            </label>
                                                            <Dropdown
                                                                id="type"
                                                                value={currentSeniority.type}
                                                                options={seniorityTypeOptions}
                                                                onChange={e =>
                                                                    setCurrentSeniority(prev => ({
                                                                        ...prev,
                                                                        type: e.value,
                                                                    }))
                                                                }
                                                                placeholder="Select Type"
                                                                className="bgclr w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col xl={12}>
                                                            <div className="d-flex justify-content-end mt-2">
                                                                <Button
                                                                    color="primary btn-main me-2"
                                                                    onClick={handleSaveSeniority}
                                                                >
                                                                    <i className="pi pi-check me-1"></i> Ok
                                                                </Button>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Dialog>
                                        </div>
                                    </AccordionTab>
                                </Accordion>

                                <Accordion
                                    className="mt-3"
                                    multiple={false}
                                // style={{ width: "100%" }}
                                >
                                    <AccordionTab header="speciality">
                                        <div>
                                            <DataTable
                                                value={specialtiesData}
                                                responsiveLayout="scroll"
                                                paginator
                                                rows={5}
                                            >
                                                <Column
                                                    field="value"
                                                    header="Value"
                                                    style={{ width: "30%" }}
                                                />
                                                <Column
                                                    field="description"
                                                    header="Description"
                                                    style={{ width: "30%" }}
                                                />
                                                <Column
                                                    field="type"
                                                    header="Type"
                                                    style={{ width: "20%" }}
                                                />
                                                <Column
                                                    header="Actions"
                                                    body={rowData => (
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                            }}
                                                        >
                                                            {editSpecialtyIcon(rowData)}
                                                            {deleteSpecialtyIcon(rowData)}
                                                        </div>
                                                    )}
                                                    style={{ width: "10%" }}
                                                />
                                            </DataTable>

                                            <div className="d-flex justify-content-end">
                                                <Button
                                                    label="Add Specialty"
                                                    icon="pi pi-plus"
                                                    onClick={addNewSpecialty}
                                                    className="mt-3"
                                                />
                                            </div>

                                            <Dialog
                                                header={
                                                    isEditingSpecialty
                                                        ? "Edit Specialty"
                                                        : "Add Specialty"
                                                }
                                                visible={isSpecialtiesDialogVisible}
                                                style={{ width: "30vw" }}
                                                onHide={handleCancelSpecialty}
                                            >
                                                <div>
                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="value" className="block">
                                                                Value
                                                            </label>
                                                            <InputText
                                                                id="value"
                                                                value={currentSpecialty.value}
                                                                onChange={e =>
                                                                    setCurrentSpecialty(prev => ({
                                                                        ...prev,
                                                                        value: e.target.value,
                                                                    }))
                                                                }
                                                                className="w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="description" className="block">
                                                                Description
                                                            </label>
                                                            <InputText
                                                                id="description"
                                                                value={currentSpecialty.description}
                                                                onChange={e =>
                                                                    setCurrentSpecialty(prev => ({
                                                                        ...prev,
                                                                        description: e.target.value,
                                                                    }))
                                                                }
                                                                className="w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="type" className="block">
                                                                Type
                                                            </label>
                                                            <Dropdown
                                                                id="type"
                                                                value={currentSpecialty.type}
                                                                options={specialtiesTypeOptions}
                                                                onChange={e =>
                                                                    setCurrentSpecialty(prev => ({
                                                                        ...prev,
                                                                        type: e.value,
                                                                    }))
                                                                }
                                                                placeholder="Select Type"
                                                                className="bgclr w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col xl={12}>
                                                            <div className="d-flex justify-content-end mt-2">
                                                                <Button
                                                                    color="primary btn-main me-2"
                                                                    onClick={handleSaveSpecialty}
                                                                >
                                                                    <i className="pi pi-check me-1"></i> Ok
                                                                </Button>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Dialog>
                                        </div>
                                    </AccordionTab>
                                </Accordion>


                                {/* Industry start */}

                                <Accordion
                                    className="mt-3"
                                    multiple={false}
                                    style={{ width: "100%" }}
                                    onClick={() => {
                                        //console.log("Accordion toggled"); // Debugging line
                                        fetchIndustry();
                                    }}
                                >
                                    <AccordionTab header="Industry" >
                                        <div>
                                            <DataTable
                                                value={industryData}
                                                responsiveLayout="scroll"
                                                paginator
                                                rows={5}
                                            >
                                                <Column
                                                    field="value"
                                                    header="Value"
                                                    style={{ width: "30%" }}
                                                />
                                                <Column
                                                    field="description"
                                                    header="Description"
                                                    style={{ width: "30%" }}
                                                />
                                                <Column
                                                    field="type"
                                                    header="Type"
                                                    style={{ width: "20%" }}
                                                />
                                                <Column
                                                    header="Actions"
                                                    body={rowData => (
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                            }}
                                                        >
                                                            {editIndustryIcon(rowData)}
                                                            {deleteIndustryIcon(rowData)}
                                                        </div>
                                                    )}
                                                    style={{ width: "10%" }}
                                                />
                                            </DataTable>

                                            <div className="d-flex justify-content-end">
                                                <Button
                                                    label="Add Industry"
                                                    icon="pi pi-plus"
                                                    onClick={addNewIndustry}
                                                    className="mt-3"
                                                />
                                            </div>

                                            <Dialog
                                                header={
                                                    isEditingIndustry ? "Edit Industry" : "Add Industry"
                                                }
                                                visible={isIndustryDialogVisible}
                                                style={{ width: "30vw" }}
                                                onHide={handleCancelIndustry}
                                            >
                                                <div>
                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="value" className="block">
                                                                Value
                                                            </label>
                                                            <InputText
                                                                id="value"
                                                                value={currentIndustry.value}
                                                                onChange={e =>
                                                                    setCurrentIndustry(prev => ({
                                                                        ...prev,
                                                                        value: e.target.value,
                                                                    }))
                                                                }
                                                                className="w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="description" className="block">
                                                                Description
                                                            </label>
                                                            <InputText
                                                                id="description"
                                                                value={currentIndustry.description}
                                                                onChange={e =>
                                                                    setCurrentIndustry(prev => ({
                                                                        ...prev,
                                                                        description: e.target.value,
                                                                    }))
                                                                }
                                                                className="w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="type" className="block">
                                                                Type
                                                            </label>
                                                            <Dropdown
                                                                id="type"
                                                                value={currentIndustry.type}
                                                                options={industryTypeOptions}
                                                                onChange={e =>
                                                                    setCurrentIndustry(prev => ({
                                                                        ...prev,
                                                                        type: e.value,
                                                                    }))
                                                                }
                                                                placeholder="Select Type"
                                                                className="bgclr w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col xl={12}>
                                                            <div className="d-flex justify-content-end mt-2">
                                                                <Button
                                                                    color="primary btn-main me-2"
                                                                    onClick={handleSaveIndustry}
                                                                >
                                                                    <i className="pi pi-check me-1"></i> Ok
                                                                </Button>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Dialog>
                                        </div>
                                    </AccordionTab>
                                </Accordion>

                                {/* Company Size */}

                                <Accordion
                                    className="mt-3"
                                    multiple={false}
                                    style={{ width: "100%" }}
                                    onTabOpen={fetchCompanySize}
                                >
                                    <AccordionTab header="Company Size">
                                        <div>
                                            <DataTable
                                                value={companySizeData}
                                                responsiveLayout="scroll"
                                                paginator
                                                rows={5}
                                            >
                                                <Column
                                                    field="value"
                                                    header="Value"
                                                    style={{ width: "30%" }}
                                                />
                                                <Column
                                                    field="description"
                                                    header="Description"
                                                    style={{ width: "30%" }}
                                                />
                                                <Column
                                                    field="type"
                                                    header="Type"
                                                    style={{ width: "20%" }}
                                                />
                                                <Column
                                                    header="Actions"
                                                    body={rowData => (
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                            }}
                                                        >
                                                            {editCompanySizeIcon(rowData)}
                                                            {deleteCompanySizeIcon(rowData)}
                                                        </div>
                                                    )}
                                                    style={{ width: "10%" }}
                                                />
                                            </DataTable>

                                            <div className="d-flex justify-content-end">
                                                <Button
                                                    label="Add Company Size"
                                                    icon="pi pi-plus"
                                                    onClick={addNewCompanySize}
                                                    className="mt-3"
                                                />
                                            </div>

                                            <Dialog
                                                header={
                                                    isEditingCompanySize
                                                        ? "Edit Company Size"
                                                        : "Add Company Size"
                                                }
                                                visible={isCompanySizeDialogVisible}
                                                style={{ width: "30vw" }}
                                                onHide={handleCancelCompanySize}
                                            >
                                                <div>
                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="value" className="block">
                                                                Company Size
                                                            </label>
                                                            <InputText
                                                                id="value"
                                                                value={currentCompanySize.value}
                                                                onChange={e =>
                                                                    setCurrentCompanySize(prev => ({
                                                                        ...prev,
                                                                        value: e.target.value,
                                                                    }))
                                                                }
                                                                className="w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="description" className="block">
                                                                Description
                                                            </label>
                                                            <InputText
                                                                id="description"
                                                                value={currentCompanySize.description}
                                                                onChange={e =>
                                                                    setCurrentCompanySize(prev => ({
                                                                        ...prev,
                                                                        description: e.target.value,
                                                                    }))
                                                                }
                                                                className="w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="type" className="block">
                                                                Type
                                                            </label>
                                                            <Dropdown
                                                                id="type"
                                                                value={currentCompanySize.type}
                                                                options={companySizeOptions}
                                                                onChange={e =>
                                                                    setCurrentCompanySize(prev => ({
                                                                        ...prev,
                                                                        type: e.value,
                                                                    }))
                                                                }
                                                                placeholder="Select Type"
                                                                className="bgclr w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col xl={12}>
                                                            <div className="d-flex justify-content-end mt-2">
                                                                <Button
                                                                    color="primary btn-main me-2"
                                                                    onClick={handleSaveCompanySize}
                                                                >
                                                                    <i className="pi pi-check me-1"></i> Ok
                                                                </Button>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Dialog>
                                        </div>
                                    </AccordionTab>
                                </Accordion>

                                {/* Schedule Type */}

                                <Accordion className="mt-3" multiple={false} style={{ width: "100%" }} onTabOpen={fetchScheduleType}>
                                    <AccordionTab header="Schedule Type" >
                                        <div>
                                            <DataTable
                                                value={scheduleTypeData}
                                                responsiveLayout="scroll"
                                                paginator
                                                rows={5}
                                            >
                                                <Column field="value" header="Schedule Type" style={{ width: "30%" }} />
                                                <Column field="description" header="Description" style={{ width: "30%" }} />
                                                <Column field="type" header="Type" style={{ width: "20%" }} />
                                                <Column
                                                    header="Actions"
                                                    body={(rowData) => (
                                                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                            {editScheduleTypeIcon(rowData)}
                                                            {deleteScheduleTypeIcon(rowData)}
                                                        </div>
                                                    )}
                                                    style={{ width: "10%" }}
                                                />
                                            </DataTable>

                                            <div className="d-flex justify-content-end">
                                                <Button
                                                    label="Add Schedule Type"
                                                    icon="pi pi-plus"
                                                    onClick={addNewScheduleType}
                                                    className="mt-3"
                                                />
                                            </div>

                                            {/* Dialog for adding/editing schedule type */}
                                            <Dialog
                                                header={isEditingScheduleType ? "Edit Schedule Type" : "Add Schedule Type"}
                                                visible={isScheduleTypeDialogVisible}
                                                style={{ width: "30vw" }}
                                                onHide={handleCancelScheduleType}
                                            >
                                                <div>
                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="value" className="block">
                                                                Schedule Type
                                                            </label>
                                                            <InputText
                                                                id="value"
                                                                value={currentScheduleType.value}
                                                                onChange={(e) =>
                                                                    setCurrentScheduleType((prev) => ({
                                                                        ...prev,
                                                                        value: e.target.value,
                                                                    }))
                                                                }
                                                                className="w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="description" className="block">
                                                                Description
                                                            </label>
                                                            <InputText
                                                                id="description"
                                                                value={currentScheduleType.description}
                                                                onChange={(e) =>
                                                                    setCurrentScheduleType((prev) => ({
                                                                        ...prev,
                                                                        description: e.target.value,
                                                                    }))
                                                                }
                                                                className="w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="type" className="block">
                                                                Type
                                                            </label>
                                                            <Dropdown
                                                                id="type"
                                                                value={currentScheduleType.type}
                                                                options={scheduleTypeOptions}
                                                                onChange={(e) =>
                                                                    setCurrentScheduleType((prev) => ({
                                                                        ...prev,
                                                                        type: e.value,
                                                                    }))
                                                                }
                                                                placeholder="Select Type"
                                                                className="bgclr w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col xl={12}>
                                                            <div className="d-flex justify-content-end mt-2">
                                                                <Button color="primary btn-main me-2" onClick={handleSaveScheduleType}>
                                                                    <i className="pi pi-check me-1"></i> Ok
                                                                </Button>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Dialog>
                                        </div>
                                    </AccordionTab>
                                </Accordion>

                                {/* Schudule sub-type */}

                                <Accordion className="mt-3" multiple={false} style={{ width: "100%" }} onTabOpen={fetchScheduleSubType}>
                                    <AccordionTab header="Schedule Sub-Type" >
                                        <div>
                                            <DataTable value={scheduleSubTypeData} responsiveLayout="scroll" paginator rows={5}>
                                                <Column field="value" header="Sub-Type" style={{ width: "30%" }} />
                                                <Column field="description" header="Description" style={{ width: "30%" }} />
                                                <Column field="type" header="Type" style={{ width: "20%" }} />
                                                <Column
                                                    header="Actions"
                                                    body={(rowData) => (
                                                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                            {editScheduleSubTypeIcon(rowData)}
                                                            {deleteScheduleSubTypeIcon(rowData)}
                                                        </div>
                                                    )}
                                                    style={{ width: "10%" }}
                                                />
                                            </DataTable>

                                            <div className="d-flex justify-content-end">
                                                <Button
                                                    label="Add Schedule Sub-Type"
                                                    icon="pi pi-plus"
                                                    onClick={addNewScheduleSubType}
                                                    className="mt-3"
                                                />
                                            </div>

                                            {/* Dialog for adding/editing schedule sub-type */}
                                            <Dialog
                                                header={isEditingScheduleSubType ? "Edit Schedule Sub-Type" : "Add Schedule Sub-Type"}
                                                visible={isScheduleSubTypeDialogVisible}
                                                style={{ width: "30vw" }}
                                                onHide={handleCancelScheduleSubType}
                                            >
                                                <div>
                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="value" className="block">Schedule Sub-Type</label>
                                                            <InputText
                                                                id="value"
                                                                value={currentScheduleSubType.value}
                                                                onChange={(e) =>
                                                                    setCurrentScheduleSubType((prev) => ({ ...prev, value: e.target.value }))
                                                                }
                                                                className="w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="description" className="block">Description</label>
                                                            <InputText
                                                                id="description"
                                                                value={currentScheduleSubType.description}
                                                                onChange={(e) =>
                                                                    setCurrentScheduleSubType((prev) => ({ ...prev, description: e.target.value }))
                                                                }
                                                                className="w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col xl={12}>
                                                            <label htmlFor="type" className="block">Type</label>
                                                            <Dropdown
                                                                id="type"
                                                                value={currentScheduleSubType.type}
                                                                options={scheduleSubTypeOptions}
                                                                onChange={(e) =>
                                                                    setCurrentScheduleSubType((prev) => ({ ...prev, type: e.value }))
                                                                }
                                                                placeholder="Select Type"
                                                                className="bgclr w-full"
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col xl={12}>
                                                            <div className="d-flex justify-content-end mt-2">
                                                                <Button color="primary btn-main me-2" onClick={handleSaveScheduleSubType}>
                                                                    <i className="pi pi-check me-1"></i> Ok
                                                                </Button>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Dialog>
                                        </div>
                                    </AccordionTab>
                                </Accordion>


                                {/* categories start */}
                                <Accordion
                                    className="mt-3"
                                    multiple={false}
                                    style={{ width: "100%" }}
                                    onTabOpen={fetchCategories}
                                >
                                    <AccordionTab header="Categories">


                                        <div className="max-w-2xl mx-auto">
                                            <div className="mb-4 d-flex justify-content-end">
                                                <Button
                                                    label="Add More"
                                                    icon="pi pi-plus"
                                                    className="p-button"
                                                    onClick={() => createNode()}
                                                />
                                            </div>
                                            <div className="border rounded-lg p-4 bg-white">
                                                {nodes.map(node => (
                                                    <RenderNode key={node.key} node={node} />
                                                ))}
                                            </div>
                                            {nodes.length > 0 && (
                                                <div className="mt-4 p-4 bg-gray-50 rounded-lg">
                                                    <h3 className="font-semibold mb-2">View the Category Component:</h3>
                                                    <TreeSelect
                                                        value={selectedNodeKey}
                                                        options={nodes}
                                                        onChange={(e) => setSelectedNodeKey(e.value)}
                                                        placeholder="Select a node"
                                                        className="w-full"
                                                    />
                                                </div>
                                            )}
                                        </div>



                                    </AccordionTab>
                                </Accordion>
                                {/* categories end */}


                                {/* Groups start */}

                                <Accordion
                                    className="mt-3"
                                    multiple={false}
                                    style={{ width: "100%" }}
                                >
                                    <AccordionTab header="Groups">


                                        <div className="max-w-2xl mx-auto">
                                            <div className="mb-4 d-flex justify-content-end">
                                                <Button
                                                    label="Add More"
                                                    icon="pi pi-plus"
                                                    className="p-button"
                                                    onClick={() => createCategory()}
                                                />
                                            </div>
                                            <div className="border rounded-lg p-4 bg-white">
                                                {categoryNodes.map(category => (
                                                    <RenderCategory key={category.key} category={category} />
                                                ))}
                                            </div>
                                            {categoryNodes.length > 0 && (
                                                <div className="mt-4 p-4 bg-gray-50 rounded-lg">
                                                    <h3 className="font-semibold mb-2">View the Group Component:</h3>
                                                    <TreeSelect
                                                        value={selectedCategoryKey}
                                                        options={categoryNodes}
                                                        onChange={(e) => setSelectedCategoryKey(e.value)}
                                                        placeholder="Select a category"
                                                        className="w-full"
                                                    />
                                                </div>
                                            )}
                                        </div>


                                    </AccordionTab>
                                </Accordion>

                                {/* Groups start */}


                            </div>


                        </div>
                    </div>

                </div >
            </Container >


            <Modal size="md" show={smShow} onHide={() => setSmShow(false)} className="text-center" >
                <Modal.Header closeButton><h1 className="modal-title fs-5 "> Delete</h1></Modal.Header>
                <div className="text-center m-3 text-danger">  </div>
                <h4 className="text-center m-2"> Are you sure you want to delete this </h4>
                <div className="text-center m-3">
                    <Button className="btn btn-primary m-1" onClick={() => setSmShow(false)} >Cancel</Button>
                    <button className="btn btn-primary m-1" onClick={deleteHandler}> Delete </button>
                </div>
            </Modal>
            <Modal size="md" show={successAlert} onHide={() => setSuccessAlert(false)} className="text-center" >
                <Modal.Header closeButton><h1 className="modal-title fs-5 "> Success</h1></Modal.Header>
                <div className="text-center m-3"> </div>
                <h4 className="text-center">Delete  Successfully</h4>
                <div className="text-center m-3">
                    <button className="btn btn-primary" onClick={() => setSuccessAlert(false)} > OK </button>
                </div>
            </Modal>

        </React.Fragment >

    )
}

export default Lookup
